import {
  Action,
  ASYNC_UPLOAD_DISPATCHER_NAME,
  ButtonActionConfig,
  CustomTagType,
  DockType,
  ErrorCodes,
  INITIAL_UPLOAD_REQUEST_MAPPING_NAME_SUFFIX,
  OperationType,
  Position,
  UpdateDialogScope,
  WarningType,
  WindowType
} from "puzzle";
import SelectSuppliers from "../components/SubmissionsList/ActionToolbar/SelectSuppliers/SelectSuppliers";
import CancelSelectedOnly from "../components/Submission/CancelSubmission/CancelSelectedOnly/CancelSelectedOnly";
import MultiBatchUpload from "../components/Submission/MultiBatchUpload/MultiBatchUpload";
import TemplateDescription from "../components/Submission/sections/Details/TemplateDescription/TemplateDescription";
import WordCount from "../components/Submission/WordCount/WordCount"
import TmConfiguration from "../components/Submission/sections/Details/TmConfiguration";
import { RejectedFilesDialog } from "../components/Submission/BatchUpload/RejectedFiles/RejectedFilesDialog";

export const selectSuppliers: Action = [{
  data: {
    template: {
      asSubName: true,
      bind: {
        submissionName: '{submissionData.submissionName}'
      }
    }
  },
  persistent: ['submissionName'],
  type: OperationType.data
}, {
  data: {
    template: {
      asSubId: true,
      bind: {
        submissionId: '{submissionData.submissionId}'
      }
    }
  },
  persistent: ['submissionId'],
  type: OperationType.data
}, {
  condition: '{submissionData}',
  conditionOperations: [{
    name: 'selectedSuppliersResponseData',
    type: OperationType.action
  }, {
    data: {
      template: {
        bind: {
          projectId: '{submissionData.projectId} || {parsedData.projectId} || {project}'
        }
      }
    },
    type: OperationType.data
  }, {
    name: 'getProjectPolicies',
    type: OperationType.action
  }, {
    data: {
      template: {
        startSubmissionPolicy: 'hasSubmissionStartPolicy'
      }
    },
    moduleName: 'Policies',
    args: ['projectId', 'startSubmissionPolicy'],
    name: 'getProjectPolicy',
    mappingName: 'hideByPolicy',
    type: OperationType.addOperationData
  }, {
    children: [{
      render: SelectSuppliers,
      propArgs: ['submissionData', 'selectedSuppliers', 'projectId']
    }],
    className: 'xl select-supplier with-custom-header',
    items: [{
      operations: [{
        name: 'onSelectSuppliersClose',
        type: OperationType.action
      }],
      btnName: 'selectSuppliers.cancel',
      close: false,
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      btnName: 'submissionName',
      btnConfig: {
        args: ['submissionId', 'submissionName', 'asSubName'],
        customTagType: CustomTagType.label,
        dock: DockType.top,
        pos: Position.end
      },
      operations: []
    }, {
      operations: [{
        data: {
          saveSelectSuppliers: true
        },
        persistent: ['saveSelectSuppliers', 'submissionId'],
        type: OperationType.addPersistentData
      }, {
        name: 'selectSuppliersSaveWarning',
        type: OperationType.action
      }],
      btnName: 'selectSuppliers.save',
      btnConfig: {
        template: {
          bind: {
            hidden: '!{selectedSuppliers.submissionStarted}',
          },
          pos: Position.end,
          themeColor: 'primary'
        }
      },
      close: false
    }, {
      operations: [{
        name: 'selectSuppliersSaveWarning',
        type: OperationType.action
      }],
      btnName: 'selectSuppliers.confirm',
      btnConfig: {
        template: {
          bind: {
            hidden: '!{selectedSuppliers.submissionStarted}',
          },
          pos: Position.end,
          themeColor: 'primary'
        }
      },
      close: false
    }, {
      operations: [{
        name: 'selectSuppliersSaveWarning',
        type: OperationType.action
      }],
      btnName: 'selectSuppliers.selectAndSave',
      btnConfig: {
        template: {
          bind: {
            hidden: '{selectedSuppliers.submissionStarted}',
          },
          pos: Position.end,
          themeColor: 'primary'
        }
      },
      close: false
    }, {
      operations: [{
        data: {
          startSubmission: true
        },
        persistent: ['startSubmission'],
        type: OperationType.addPersistentData
      }, {
        name: 'selectSuppliersStartWarning',
        type: OperationType.action
      }],
      btnName: 'selectSuppliers.selectAndStart',
      btnConfig: {
        template: {
          bind: {
            hidden: '!{selectedSuppliers.submissionHasDueDate} || {selectedSuppliers.fileCount === 0} || {selectedSuppliers.submissionStarted} || !{hideByPolicy}',
          },
          pos: Position.end,
          themeColor: 'primary'
        }
      },
      close: false
    }, {
      operations: [{
        moduleName: 'SelectSuppliers',
        name: 'clearAll'
      }],
      btnName: 'selectSuppliers.clearAll',
      btnConfig: {
        fillMode: 'outline',
        pos: Position.start
      },
      close: false
    }, {
      btnName: 'ESCAPE',
      close: false,
      operations: [{
        name: 'onSelectSuppliersClose',
        type: OperationType.action
      }]
    }],
    title: 'selectSuppliers.title',
    type: OperationType.dialog
  }],
  type: OperationType.conditional
}];

export const updateSelectSuppliers: Action = [{
  customTags: [{
    name: 'selectSuppliers.switch',
    hidden: '{hideSwitcher}'
  }],
  type: OperationType.updateDialog
}];

export const changeSelectSuppliersGrouping: Action = [{
  moduleName: 'SelectSuppliers',
  name: 'changeGroupingType'
}]

const cancelStartSelectSupplier: ButtonActionConfig[] = [{
  btnName: 'ESCAPE',
  operations: [{
    persistent: ['startSubmission'],
    type: OperationType.removePersistentData
  }]
}, {
  operations: [{
    persistent: ['startSubmission'],
    type: OperationType.removePersistentData
  }],
  btnName: 'common.cancel',
  btnConfig: {
    fillMode: 'flat',
    pos: Position.end
  }
}]

export const selectSuppliersStartWarning: Action = [{
  moduleName: 'SelectSuppliers',
  name: 'checkIsAllPhasesSelected',
  mappingName: 'allPhasesSelected',
  type: OperationType.addOperationData
}, {
  moduleName: 'SelectSuppliers',
  name: 'checkIsSomeUnclaimed',
  mappingName: 'isUnclaimed',
  type: OperationType.addOperationData
}, {
  condition: '{isUnclaimed}',
  conditionOperations: [{
    className: 'sm info',
    warningType: WarningType.info,
    text: 'selectSuppliersStartWarningUnclaimed.text',
    title: 'selectSuppliersStartWarningUnclaimed.title',
    type: OperationType.warning,
    items: [...cancelStartSelectSupplier, {
      operations: [{
        windowType: WindowType.warning,
        type: OperationType.closeWindow
      }, {
        name: 'SelectSuppliersSaveRequests',
        type: OperationType.action
      }],
      btnName: 'selectSuppliersWarningButtons.ok',
      close: false,
      btnConfig: {
        fillMode: 'flat',
        themeColor: 'primary',
        pos: Position.end
      }
    }]
  }],
  elseOperations: [{
    condition: '{allPhasesSelected}',
    conditionOperations: [{
      className: 'sm',
      text: 'selectSuppliersStartWarning.text',
      title: 'selectSuppliersStartWarning.title',
      type: OperationType.warning,
      items: [...cancelStartSelectSupplier, {
        operations: [{
          windowType: WindowType.warning,
          type: OperationType.closeWindow
        }, {
          name: 'SelectSuppliersSaveRequests',
          type: OperationType.action
        }],
        btnName: 'selectSuppliersWarningButtons.ok',
        btnConfig: {
          themeColor: 'primary',
          pos: Position.end
        }
      }]
    }],
    elseOperations: [{
      className: 'sm',
      text: 'selectSuppliersStartWarningMissingSelection.text',
      title: 'selectSuppliersStartWarningMissingSelection.title',
      type: OperationType.warning,
      items: [...cancelStartSelectSupplier, {
        operations: [{
          name: 'SelectSuppliersSaveRequests',
          type: OperationType.action
        }],
        btnName: 'selectSuppliersWarningButtons.ok',
        btnConfig: {
          themeColor: 'primary',
          pos: Position.end
        }
      }]
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const selectSuppliersSaveWarning: Action = [{
  moduleName: 'SelectSuppliers',
  name: 'checkIsAllPhasesSelected',
  mappingName: 'allPhasesSelected',
  type: OperationType.addOperationData
}, {
  moduleName: 'SelectSuppliers',
  name: 'checkIsSomeUnclaimed',
  mappingName: 'isUnclaimed',
  type: OperationType.addOperationData
}, {
  condition: '{isUnclaimed}',
  conditionOperations: [{
    className: 'sm',
    text: 'selectSuppliersSaveWarningUnclaimed.text',
    title: 'selectSuppliersSaveWarningUnclaimed.title',
    type: OperationType.warning,
    items: [{
      operations: [{
        windowType: WindowType.warning,
        type: OperationType.closeWindow
      }],
      btnName: 'selectSuppliersWarningButtons.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      operations: [{
        windowType: WindowType.warning,
        type: OperationType.closeWindow
      }, {
        name: 'SelectSuppliersSaveRequests',
        type: OperationType.action
      }],
      btnName: 'selectSuppliersWarningButtons.unclaim',
      close: false,
      btnConfig: {
        themeColor: 'error',
        pos: Position.end
      }
    }]
  }],
  elseOperations: [{
    condition: '{allPhasesSelected}',
    conditionOperations: [{
      className: 'sm',
      text: 'selectSuppliersSaveWarning.text',
      title: 'selectSuppliersSaveWarning.title',
      type: OperationType.warning,
      items: [{
        operations: [{
          windowType: WindowType.warning,
          type: OperationType.closeWindow
        }],
        btnName: 'selectSuppliersWarningButtons.cancel',
        btnConfig: {
          fillMode: 'flat',
          pos: Position.end
        }
      }, {
        operations: [{
          windowType: WindowType.warning,
          type: OperationType.closeWindow
        }, {
          name: 'SelectSuppliersSaveRequests',
          type: OperationType.action
        }],
        btnName: 'selectSuppliersWarningButtons.save',
        close: false,
        btnConfig: {
          themeColor: 'primary',
          pos: Position.end
        }
      }]
    }],
    elseOperations: [{
      className: 'sm',
      text: 'selectSuppliersSaveWarningMissingSelection.text',
      title: 'selectSuppliersSaveWarningMissingSelection.title',
      type: OperationType.warning,
      items: [{
        operations: [{
          windowType: WindowType.warning,
          type: OperationType.closeWindow
        }],
        btnName: 'selectSuppliersWarningButtons.cancel',
        btnConfig: {
          fillMode: 'flat',
          pos: Position.end
        }
      }, {
        operations: [{
          windowType: WindowType.warning,
          type: OperationType.closeWindow
        }, {
          name: 'SelectSuppliersSaveRequests',
          type: OperationType.action
        }],
        close: false,
        btnName: 'selectSuppliersWarningButtons.save',
        btnConfig: {
          themeColor: 'primary',
          pos: Position.end
        }
      }]
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const onSelectSuppliersClose: Action = [{
  moduleName: 'SelectSuppliers',
  name: 'checkForDifferences',
  type: OperationType.addOperationData
}, {
  condition: '!{checkForDifferences}',
  conditionOperations: [{
    name: 'cancelWarningDialog',
    type: OperationType.action
  }],
  elseOperations: [{
    windowType: WindowType.warning,
    type: OperationType.closeWindow
  }, {
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}];

export const cancelWarningDialog: Action = [{
  className: 'sm footer-centered',
  title: 'selectSuppliersWarning.closeSelectSuppliers',
  text: 'selectSuppliersWarning.cancelMsg',
  items: [{
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'selectSuppliersWarning.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {

    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    btnName: 'selectSuppliersWarning.close',
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    }
  }],
  type: OperationType.warning
}];

export const selectedSuppliersResponseData: Action = [{
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'get',
    template: {
      bind: {
        url: `"/submissions/" + {submissionId} + "/selectSuppliers"`
      }
    }
  },
  mappingName: 'selectedSuppliersResponseData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{selectedSuppliersResponseData}',
        selectedSuppliers: '{selectedSuppliersResponseData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}]

export const SelectSuppliersSaveRequests: Action = [{
  moduleName: 'SelectSuppliers',
  name: 'getUnclaimData',
  mappingName: 'unclaimData',
  type: OperationType.addOperationData
}, {
  condition: '{unclaimData.jsonData.length}',
  conditionOperations: [{
    data: {
      handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
      method: 'post',
      template: {
        bind: {
          params: '{unclaimData.jsonData}',
          url: `"/submissions/" + {unclaimData.submissionId} + "/unclaim"`
        }
      },
    },
    mappingName: 'unclaimResponseData',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{unclaimResponseData}'
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  moduleName: 'SelectSuppliers',
  name: 'getSelectSuppliersData',
  mappingName: 'selectSuppliersData',
  type: OperationType.addOperationData
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    template: {
      bind: {
        params: '{selectSuppliersData.jsonData}',
        url: `"/submissions/" + {selectSuppliersData.submissionId} + "/selectSuppliers"`
      }
    },
  },
  mappingName: 'selectSuppliersResponseData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{selectSuppliersResponseData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'SelectSuppliers',
  name: 'getAssignData',
  mappingName: 'assignData',
  type: OperationType.addOperationData
}, {
  condition: '{assignData.jsonData.length}',
  conditionOperations: [{
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    data: {
      method: 'post',
      template: {
        bind: {
          params: '{assignData.jsonData}',
          url: `"/submissions/" + {assignData.submissionId} + "/assign"`
        }
      },
    },
    mappingName: 'assignDataResponse',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{assignDataResponse}'
        }
      }
    },
    type: OperationType.data
  }, {
    name: 'handleRequestException',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  condition: '{saveSelectSuppliers}',
  conditionOperations: [{
    moduleName: 'SelectSuppliers',
    name: 'getSelectSuppliersData',
    mappingName: 'selectSuppliersData',
    type: OperationType.addOperationData
  }, {
    data: {
      template: {
        bind: {
          submissionId: '{selectSuppliersData.submissionId}'
        }
      }
    },
    type: OperationType.data
  }, {
    name: 'selectedSuppliersResponseData',
    type: OperationType.action
  }, {
    name: 'setData',
    args: ['selectedSuppliers'],
    moduleName: 'SelectSuppliers'
  }],
  elseOperations: [{
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}, {
  name: 'refreshApp',
  type: OperationType.action
}, {
  condition: '{startSubmission}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          submissionData: '{selectSuppliersData}'
        }
      },
    },
    type: OperationType.data
  }, {
    name: 'startSubmissionRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  persistent: ['startSubmission', 'saveSelectSuppliers', 'submissionId'],
  type: OperationType.removePersistentData
}];

export const downloadAllDeliverables: Action = [{
  name: 'pingUntilDownloadIsReady',
  type: OperationType.action
}];

export const downloadReferenceFiles: Action = [{
  name: 'pingUntilDownloadIsReady',
  type: OperationType.action
}];

export const downloadAuditLog: Action = [{
  name: 'pingUntilDownloadIsReady',
  type: OperationType.action
}];

export const downloadDocument: Action = [{
  data: {
    template: {
      isDownload: true,
      downloadType: 'blob',
      method: 'post',
      url: '/resources/download',
      bind: {
        params: '{params}'
      }
    }
  },
  mappingName: 'downloadData',
  type: OperationType.request,
}];


export const downloadInstructions: Action = [{
  data: {
    template: {
      downloadType: 'blob',
      isDownload: true,
      method: 'get',
      bind: {
        url: '{url}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'downloadData',
  type: OperationType.request,
}, {
  data: {
    template: {
      bind: {
        responseData: '{downloadData}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'ActionExecutor',
  name: 'downloadFile',
  args: ['downloadData']
}];

export const getSubmissionStatus: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'getProjectPolicies',
  type: OperationType.action
}, {
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/" + {submissionId} + "/batchlanguages/status"',
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'submissionStatus',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{submissionStatus}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        disableDownloadDeliverable: '!({selectedSubmissions[0].hasCompletedTargets} || {selectedSubmissions[0].hasDeliveredTargets})'
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'SubmissionStatus',
  name: 'loadSubmissionStatus',
  args: ['submissionStatus', 'disableDownloadDeliverable'],
  type: OperationType.addOperationData
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const getTaskDetails: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  persistent: ['submissionId'],
  type: OperationType.addPersistentData
}, {
  name: 'getTaskById',
  type: OperationType.action
}, {
  moduleName: 'SubmissionDetails',
  name: 'setData',
  args: ['details'],
  type: OperationType.addOperationData
}, {
  persistent: ['submissionId'],
  type: OperationType.removePersistentData
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}

]

export const getTaskById: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: `"/jobPhases/" + {submissionId} + "/details"`
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'details',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action

}]

export const getSubmissionDetails: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/submissions/" + {submissionId} + "/details"'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}]

export const getAndLoadSubmissionDetails: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  name: 'getProjectPolicies',
  type: OperationType.action
}, {
  persistent: ['submissionId'],
  type: OperationType.addPersistentData
}, {
  name: 'getSubmissionDetails',
  type: OperationType.action
}, {
  moduleName: 'SubmissionDetails',
  name: 'setData',
  args: ['responseData'],
  type: OperationType.addOperationData
}, {
  persistent: ['submissionId'],
  type: OperationType.removePersistentData
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const getSubmissionById: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/submissions/" + {submissionId}'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'submissionDetails',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{submissionDetails}',
        submissionDetails: '{submissionDetails}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}];

export const getProjectById: Action = [{
  data: {
    template: {
      bind: {
        url: '"/projects/" + {submissionDetails.projectId}'
      },
      method: 'get'
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'projectResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{projectResponse}',
        project: '{projectResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}];

export const uploadWarning: Action = [{
  warningType: WarningType.info,
  text: 'batchUpload.text',
  title: 'batchUpload.title',
  type: OperationType.warning,
  items: [{
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'batchUpload.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }]
}];

export const deleteSupplementaryFilesDialog: Action = [{
  persistent: ['fileCount', 'repositoryTickets', 'submissionId', 'urlDelete', 'urlLoadData'],
  type: OperationType.addPersistentData
}, {
  placeholders: {
    className: 'tp-text-semibold',
    template: {
      bind: {
        fileCount: '{fileCount}',
      }
    }
  },
  title: 'supplementaryFiles.title',
  text: 'supplementaryFiles.text',
  className: 'sm',
  items: [{
    btnName: 'supplementaryFiles.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      type: OperationType.closeWindow
    }, {
      persistent: ['fileCount', 'repositoryTickets', 'submissionId', 'urlDelete', 'urlLoadData'],
      type: OperationType.removePersistentData
    }]
  }, {
    btnName: 'supplementaryFiles.delete',
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    },
    operations: [{
      moduleName: 'App',
      type: OperationType.maskModule
    }, {
      data: {
        method: 'post',
        template: {
          bind: {
            url: `{urlDelete}`,
            params: '{repositoryTickets}'
          },
        }
      },
      type: OperationType.request
    }, {
      data: {
        template: {
          bind: {
            submissionId: '{submissionId}',
            url: `{urlLoadData}`
          }
        }
      },
      name: 'getSupplementaryFilesData',
      type: OperationType.action
    }, {
      persistent: ['fileCount', 'repositoryTickets', 'submissionId', 'urlDelete', 'urlLoadData'],
      type: OperationType.removePersistentData
    }]
  }],
  type: OperationType.dialog
}]

export const getSupplementaryFilesData: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    method: 'get',
    template: {
      bind: {
        url: `{url}`
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  moduleName: 'SupplementaryFiles',
  args: ['responseData'],
  name: 'setData'
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}]

export const duplicateFilesWarning: Action = [{
  warningType: WarningType.info,
  placeholders: {
    template: {
      bind: {
        files: '{files}',
      }
    }
  },
  className: 'sm info footer-centered',
  title: 'duplicateFilesWarning.rejectedFiles',
  text: 'duplicateFilesWarning.uploadDuplicatesMessage',
  type: OperationType.warning,
  items: [{
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'duplicateFilesWarning.closeBtn',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.start
    }
  }]
}];

export const filePath: Action = [{
  persistent: ['fileName'],
  type: OperationType.addPersistentData
}, {
  placeholders: {
    template: {
      bind: {
        fileName: '{fileName}',
      }
    }
  },
  title: 'filePathInfo.title',
  text: 'filePathInfo.text',
  type: OperationType.warning,
  className: 'sm file-path',
  items: [{
    btnName: 'filePathInfo.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      name: 'copyFileNameOrPath',
      type: OperationType.action
    }],
    btnName: 'filePathInfo.copy',
    btnConfig: {
      accessibility: {
        ariaLabel: '',
        iconAriaHidden: true
      },
      iconClass: 'tp-icon tp-copy-to-clipboard',
      themeColor: 'primary',
      pos: Position.end
    }
  }]
}];

export const copyFileNameOrPath: Action = [{
  moduleName: 'App',
  localeProperty: 'SRL-fileNameCopyMsg',
  type: OperationType.maskModule
}, {
  name: 'copyToClipboardBtnAction',
  delay: 100,
  synchronous: true,
  args: ['fileName'],
  moduleName: 'ActionExecutor'
}, {
  persistent: ['fileName'],
  type: OperationType.removePersistentData
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const invalidDropWarning: Action = [{
  warningType: WarningType.info,
  text: 'batchUpload.message',
  title: 'batchUpload.notSupported',
  type: OperationType.warning,
  items: [{
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'batchUpload.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }]
}];

export const enableProject: Action = [{
  moduleName: 'Details',
  name: 'enableProject'
}];

export const uploadFiles: Action = [{
  persistent: ['dropUploadModuleId', 'projectIdFromTemplate'],
  type: OperationType.addPersistentData
}, {
  condition: `!{uploadParams.submissionFolder} && ({dropUploadModuleId} !== "supplementaryFiles")`,
  conditionOperations: [{
    moduleName: 'Details',
    name: 'disableProject',
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  args: ['uploadFiles'],
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{dropUploadModuleId}',
  name: 'updateUpdatedFiles'
}, {
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{dropUploadModuleId}',
  name: 'getSubmissionFolder',
  mappingName: 'submissionFolder',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      params: {
        bind: {
          projectId: '{uploadParams.projectId}'
        }
      }
    }
  },
  type: OperationType.data
}, {
  showProgress: false,
  uniqueParameter: 'submissionFolder',
  mappingName: 'uploadStatus',
  uploadCondition: 'submissionFolder',
  afterInitialRequest: [{
    condition: '!{submissionFolder}',
    conditionOperations: [{
      data: {
        template: {
          bind: {
            submissionFolder: `{uploadStatus${INITIAL_UPLOAD_REQUEST_MAPPING_NAME_SUFFIX}.submissionFolder}`
          }
        }
      },
      type: OperationType.data
    }, {
      args: ['submissionFolder'],
      moduleName: 'DropUpload',
      evaluate: true,
      moduleId: '{dropUploadModuleId}',
      name: 'saveSubmissionFolder'
    }],
    type: OperationType.conditional
  }, {
    data: {
      template: {
        bind: {
          sentUploadRequest: '{uploadParams}'
        }
      }
    },
    persistent: ['sentUploadRequest'],
    type: OperationType.addPersistentData
  }],
  data: {
    method: 'post',
    url: "/submissions/upload/temporary"
  },
  operations: [{
    items: ['sentUploadRequest', 'dropUploadModuleId'],
    referenceDispatcherId: ASYNC_UPLOAD_DISPATCHER_NAME,
    type: OperationType.syncDispatchersDataItem
  }, {
    moduleName: 'DropUpload',
    name: 'dropUploadStatus',
    args: ['uploadStatus', 'sentUploadRequest', 'uploadStatus_multiErrors'],
    type: OperationType.addOperationData
  }, {
    condition: '{projectIdFromTemplate}',
    conditionOperations: [{
      moduleName: 'DropUpload',
      moduleId: 'MultiBatchUpload_0',
      name: 'getFiles',
      mappingName: 'droppedFiles',
      type: OperationType.addOperationData
    }, {
      moduleName: 'BatchesContent',
      name: 'updateBatchInfosWithFileFromTemplate',
      args: ['droppedFiles'],
      type: OperationType.addOperationData
    }],
    type: OperationType.conditional
  }, {
    persistent: ['dropUploadModuleId', 'uploadStatus', 'projectIdFromTemplate'],
    type: OperationType.removePersistentData
  }],
  handleFileRejection: [{
    items: ['group'],
    type: OperationType.syncDispatchersDataItem
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'handleFileRejection',
    type: OperationType.action
  }],
  progressOperations: [{
    moduleName: 'DropUpload',
    args: ['progresses'],
    name: 'setUploadProgress'
  }],
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  afterInitialRequestHandleErrorStatus: [{
    data: {
      template: {
        bind: {
          responseData: '{uploadStatus_INITIAL}'
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }],
  afterPingRequestHandleErrorStatus: [{
    data: {
      template: {
        bind: {
          responseData: '{uploadStatus_multiErrors[0]}'
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }],
  type: OperationType.upload
}];

export const handleFileRejection = [{
  moduleName: 'DropUpload',
  name: 'removeFailedFilesFromGrid'
}, {
  args: ['group'],
  name: 'handleRejectionCode',
  moduleName: 'DropUpload',
  mappingName: 'rejectedFilesData',
  type: OperationType.addOperationData
}, {
  name: 'rejectedFilesDialog',
  type: OperationType.action
}]

export const rejectedFilesDialog = [{
  title: 'rejectedFiles.title',
  className: 'sm footer-centered',
  warningType: WarningType.warning,
  children: [{
    render: RejectedFilesDialog,
    propArgs: ['rejectedFilesData']
  }],
  items: [{
    btnName: 'ESCAPE',
    operations: [{
      persistent: ['isRejectedAfterSave', 'rejectedFilesData'],
      type: OperationType.removePersistentData
    }]
  }, {
    btnName: 'rejectedFiles.close',
    operations: [{
      condition: '{isRejectedAfterSave}',
      conditionOperations: [{
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }],
      elseOperations: [{
        windowType: WindowType.warning,
        type: OperationType.closeWindow
      }],
      type: OperationType.conditional
    }, {
      persistent: ['isRejectedAfterSave', 'rejectedFilesData'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  type: OperationType.dialog
}];

export const rejectedSupplementaryFiles: Action = [{
  args: ['group'],
  name: 'handleRejectionCode',
  moduleName: 'DropUpload',
  mappingName: 'rejectedFilesData',
  type: OperationType.addOperationData
}, {
  data: {
    isRejectedAfterSave: true //Checks if rejected files warning is opened from Supplementary Files save button
  },
  persistent: ['isRejectedAfterSave', 'rejectedFilesData'],
  type: OperationType.addPersistentData
}, {
  name: 'rejectedFilesDialog',
  type: OperationType.action
}]

export const updateBatchUploadDialog: Action = [{
  buttons: [
    {
      name: 'multiBatchUpload.save',
      disabled: '{uploadIsInProgress}'
    }
  ],
  scope: UpdateDialogScope.all,
  type: OperationType.updateDialog
}]

export const checkSubmissionValidity: Action = [{
  moduleName: 'View',
  name: 'validateSubmission',
  args: ['staticFields'],
  mappingName: 'isSubmissionValid',
  type: OperationType.addOperationData
}];

export const getProjectForSubmission: Action = [{
  condition: '{submissionMode} === "TEMPLATE_CREATE" || {submissionMode} === "TEMPLATE_EDIT"',
  conditionOperations: [{
    data: {
      url: '/projects/createTemplatePolicy',
    },
    type: OperationType.data
  }],
  elseOperations: [{
    condition: '{submissionMode} === "EDIT"',
    conditionOperations: [{
      data: {
        url: '/projects/editSubmissionPolicy',
      },
      type: OperationType.data
    }],
    elseOperations: [{
      data: {
        url: '/projects/createSubmissionPolicy',
      },
      type: OperationType.data
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}, {
  data: {
    method: 'get',
    template: {
      bind: {
        url: '{url}'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'submissionProjects',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{submissionProjects}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'Details',
  name: 'setProjectData',
  args: ['submissionProjects'],
  type: OperationType.addOperationData
}];

export const getTemplatesForSubmission: Action = [{
  name: 'templatesSearch',
  type: OperationType.action
}, {
  moduleName: 'Create',
  name: 'setTemplatesData',
  args: ['templatesData'],
  type: OperationType.addOperationData
}];

export const enableUpload: Action = [{
  moduleName: 'DropUpload',
  name: 'enableUpload',
  args: ['projectId'],
  type: OperationType.addOperationData
}];

export const getLanguagesDirections: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/projects/"+ {projectId} +"/languagedirections"'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'languagesResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{languagesResponse}',
        languages: '{languagesResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}];

/**
 * Request hanndeler and setter for languagedirections in TPT mode
 */
export const getTptModeLanguagesDirections: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/projects/" + {projectId} + "/paClient/" + {paClientId} + "/languagedirections"'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'Details',
  name: 'setLanguagesData',
  args: ['responseData']
}, {
  moduleName: 'Details',
  name: 'preselectSourceLanguage'
}, {
  moduleName: 'Details',
  name: 'preselectTargetLanguage'
}, {
  moduleName: 'Details',
  name: 'getDefaultTargetLanguagesData',
  mappingName: 'defaultTargetLanguages',
  type: OperationType.addOperationData
}, {
  condition: '{defaultTargetLanguages.length}',
  conditionOperations: [{
    moduleName: 'DropUpload',
    moduleId: 'fromInstructions',
    name: 'setTargetLanguages',
    args: ['defaultTargetLanguages']
  }],
  type: OperationType.conditional
}];


export const getDataByProject: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/projects/"+ {projectId} +"/users/org"'
      }
    }
  },
  mappingName: 'usersResponse',
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{usersResponse}',
        users: '{usersResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  condition: `_.get({initializeUserData}, 'applicationInfo.tptEnabled')`,
  conditionOperations: [{
    name: 'getPaClients',
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  moduleName: 'Details',
  name: 'setProjectManagers',
  args: ['users']
}, {
  condition: '!_.get({initializeUserData}, "applicationInfo.tptEnabled")', //setting languageDirections is handled different on TPT mode.
  conditionOperations: [{
    name: 'getLanguagesDirections',
    type: OperationType.action
  }, {
    moduleName: 'Details',
    name: 'setLanguagesData',
    args: ['languages']
  }],
  elseOperations: [{
    condition: '_.includes(["EDIT","CLONE","TEMPLATE_EDIT"], {submissionMode}) || {afterTemplateChange}',
    conditionOperations: [{
      data: {
        template: {
          bind: {
            paClientId: '_.get({parsedSubmissionData},"details.paClient"})'
          }
        }
      },
      name: 'getTptModeLanguagesDirections',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/projects/"+ {projectId} +"/workflows"'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'workflowsResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{workflowsResponse}',
        workflows: '{workflowsResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'Content',
  name: 'setWorkflowData',
  args: ['workflows', 'defaultWorkflowId']
}, {
  moduleName: 'Details',
  name: 'setWorkflowData',
  args: ['workflows', 'defaultWorkflowId']
}, {
  moduleName: 'Details',
  name: 'isMslaEnabled',
  args: ['projectId'],
  type: OperationType.addOperationData
}, {
  condition: '{isMslaEnabled}',
  conditionOperations: [{
    name: 'getMslaLevel',
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      mslaLevelData: []
    },
    moduleName: 'Details',
    name: 'setPriorityLevelsData',
    args: ['mslaLevelData']
  }],
  type: OperationType.conditional
}, {
  moduleName: 'Details',
  name: 'hasRequestQuotePolicy',
  type: OperationType.addOperationData
}, {
  condition: '{hasRequestQuotePolicy}',
  conditionOperations: [{
    data: {
      template: {
        method: 'get',
        bind: {
          url: '"/projects/"+ {projectId} +"/quote/configuration"'
        }
      }
    },
    mappingName: 'quoteConfig',
    type: OperationType.request
  }, {
    args: ['quoteConfig'],
    moduleName: 'Details',
    name: 'setQuoteConfigData'
  }],
  type: OperationType.conditional
}, {
  moduleName: 'Details',
  name: 'findProjectById',
  args: ['projectId'],
  mappingName: 'projectData',
  type: OperationType.addOperationData
}, {
  condition: '{projectData}',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          mediaAssetsEnabled: '{projectData.mediaAssetsEnabled}'
        }
      }
    },
    moduleName: 'View',
    name: 'setMediaAssetsVisibility',
    args: ['mediaAssetsEnabled']
  }],
  type: OperationType.conditional
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/projects/"+ {projectId} +"/customattributes"'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'submissionCustomFields',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{submissionCustomFields}',
        submissionCustomFields: '{submissionCustomFields}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'CustomFields',
  name: 'setFields',
  args: ['submissionCustomFields'],
  type: OperationType.addOperationData
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}, {
  moduleName: 'Details',
  name: 'projectDataLoadFinished'
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/projects/"+ {projectId} +"/fileformats"'
      }
    }
  },
  mappingName: 'submissionFileFormats',
  type: OperationType.request
}, {
  moduleName: 'DropUpload',
  moduleId: 'fromContent',
  name: 'setProjectFileFormats',
  args: ['submissionFileFormats']
}, {
  moduleName: 'Content',
  name: 'setFileFormat',
  args: ['submissionFileFormats']
}];

export const getPaClients: Action = [{
  moduleName: 'PaClient',
  name: 'getPaClientPageInfo',
  mappingName: 'pageInfo',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        name: '{pageInfo.name}',
        pageNumber: '{pageInfo.pageNumber}',
        pageSize: '{pageInfo.pageSize}'
      }
    }
  },
  type: OperationType.data
}, {
  condition: '_.includes(["EDIT","CLONE","TEMPLATE_EDIT"], {submissionMode}) && _.get({parsedSubmissionData},"details.projectAClientName"})',
  conditionOperations: [{
    data: {
      template: {
        bind: {
          name: '_.get({parsedSubmissionData},"details.projectAClientName"})'
        }
      }
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: "'/projects/'+{projectId}+'/paClients?pageSize='+{pageSize}+'&pageNumber='+{pageNumber}+'&name='+{name}+'&enabled=true&orderBy=projectaclientname&orderType=ASCENDING'",
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'PaClient',
  name: 'setPaClientData',
  args: ['responseData']
}];

export const getMslaLevel: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/projects/"+{projectId}+"/mslalevels"'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'mslaLevelData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{mslaLevelData}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  moduleName: 'Details',
  name: 'setPriorityLevelsData',
  args: ['mslaLevelData']
}];

/**
 * Parses data for all submissionModes and checks for errors in files being uploaded
 * If there are no errors in parsedData, sets 'parsedDataWithoutErrors' to true
 */
export const getParsedSubmissionData: Action = [{
  moduleName: 'Details',
  name: 'getData',
  mappingName: 'detailsData',
  type: OperationType.addOperationData
}, {
  moduleName: 'Content',
  name: 'getData',
  mappingName: 'contentData',
  type: OperationType.addOperationData
}, {
  moduleName: 'Instructions',
  name: 'getData',
  mappingName: 'instructionsData',
  type: OperationType.addOperationData
}, {
  moduleName: 'CustomFields',
  name: 'getData',
  mappingName: 'customFieldsData',
  type: OperationType.addOperationData
}, {
  condition: '{submissionMode}',
  CREATE: [{
    moduleName: 'Create',
    name: 'parseDataForCreate',
    args: ['detailsData', 'contentData', 'instructionsData', 'customFieldsData'],
    mappingName: 'parsedData',
    type: OperationType.addOperationData
  }],
  CLONE: [{
    moduleName: 'Clone',
    name: 'parseDataForCreate',
    args: ['detailsData', 'contentData', 'instructionsData', 'customFieldsData'],
    mappingName: 'parsedData',
    type: OperationType.addOperationData
  }],
  TEMPLATE_CREATE: [{
    moduleName: 'TemplateCreate',
    name: 'parseDataForCreate',
    args: ['detailsData', 'contentData', 'instructionsData', 'customFieldsData'],
    mappingName: 'parsedData',
    type: OperationType.addOperationData
  }],
  TEMPLATE_CLONE: [{
    data: {
      cloneTemplate: true
    },
    moduleName: 'TemplateEdit',
    name: 'parseDataForCreate',
    args: ['detailsData', 'contentData', 'instructionsData', 'customFieldsData', 'cloneTemplate'],
    mappingName: 'parsedData',
    type: OperationType.addOperationData
  }],
  EDIT: [{
    moduleName: 'Edit',
    name: 'parseDataForEdit',
    args: ['detailsData', 'contentData', 'instructionsData', 'customFieldsData'],
    mappingName: 'parsedData',
    type: OperationType.addOperationData
  }, {
    data: {
      editSubmissionCompleted: false
    },
    persistent: ['editSubmissionCompleted'],
    type: OperationType.addPersistentData
  }],
  TEMPLATE_EDIT: [{
    moduleName: 'TemplateEdit',
    name: 'parseDataForEdit',
    args: ['detailsData', 'contentData', 'instructionsData', 'customFieldsData'],
    mappingName: 'parsedData',
    type: OperationType.addOperationData
  }, {
    data: {
      editSubmissionCompleted: false
    },
    persistent: ['editSubmissionCompleted'],
    type: OperationType.addPersistentData
  }],
  type: OperationType.switch
}, {
  data: {
    template: {
      bind: {
        isTemplate: '{parsedData.isTemplate}'
      }
    }
  },
  persistent: ['isTemplate'],
  type: OperationType.addPersistentData
}, {
  data: {
    parsedDataWithoutErrors: false
  },
  type: OperationType.data
}, {
  condition: '{parsedData.targetFormatError}',
  conditionOperations: [{
    items: [{
      operations: [{
        windowType: WindowType.warning,
        type: OperationType.closeWindow
      }],
      btnName: 'submissionTargetFormatError.close',
      btnConfig: {
        themeColor: 'primary',
        pos: Position.start
      }
    }],
    className: 'sm info footer-centered',
    warningType: WarningType.error,
    text: 'submissionTargetFormatError.text',
    title: 'submissionTargetFormatError.title',
    type: OperationType.warning
  }],
  elseOperations: [{
    condition: '{parsedData.uploadedFilesError}',
    conditionOperations: [{
      items: [{
        operations: [{
          windowType: WindowType.warning,
          type: OperationType.closeWindow
        }],
        btnName: 'submissionUploadedFilesError.close',
        btnConfig: {
          themeColor: 'primary',
          pos: Position.start
        }
      }],
      className: 'sm',
      warningType: WarningType.error,
      text: 'submissionUploadedFilesError.text',
      title: 'submissionUploadedFilesError.title',
      type: OperationType.warning
    }],
    elseOperations: [{
      condition: '{parsedData.referenceFilesError}',
      conditionOperations: [{
        items: [{
          operations: [{
            windowType: WindowType.warning,
            type: OperationType.closeWindow
          }],
          btnName: 'referenceFilesError.close',
          btnConfig: {
            themeColor: 'primary',
            pos: Position.start
          }
        }],
        className: 'sm',
        warningType: WarningType.error,
        text: 'referenceFilesError.text',
        title: 'referenceFilesError.title',
        type: OperationType.warning
      }],
      elseOperations: [{
        condition: '{parsedData.notAssignedLanguages}',
        conditionOperations: [{
          items: [{
            operations: [{
              windowType: WindowType.warning,
              type: OperationType.closeWindow
            }],
            btnName: 'targetLanguagesNotAssigned.ok',
            btnConfig: {
              themeColor: 'primary',
              pos: Position.start
            }
          }],
          className: 'sm',
          warningType: WarningType.error,
          text: 'targetLanguagesNotAssigned.text',
          title: 'targetLanguagesNotAssigned.title',
          type: OperationType.warning
        }],
        elseOperations: [{
          data: {
            parsedDataWithoutErrors: true
          },
          type: OperationType.data
        }],
        type: OperationType.conditional
      }],
      type: OperationType.conditional
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const setInitDataForEdit: Action = [{
  name: 'getDataForEdit',
  type: OperationType.action
}, {
  moduleName: 'View',
  name: 'setSubmissionSnapshot',
  args: ['parsedData'],
  type: OperationType.addOperationData
}];

export const getDataForEdit: Action = [{
  moduleName: 'Details',
  name: 'getData',
  mappingName: 'detailsData',
  type: OperationType.addOperationData
}, {
  moduleName: 'Content',
  name: 'getData',
  mappingName: 'contentData',
  type: OperationType.addOperationData
}, {
  moduleName: 'Instructions',
  name: 'getData',
  mappingName: 'instructionsData',
  type: OperationType.addOperationData
}, {
  moduleName: 'CustomFields',
  name: 'getData',
  mappingName: 'customFieldsData',
  type: OperationType.addOperationData
}, {
  moduleName: 'Edit',
  name: 'parseDataForEdit',
  args: ['detailsData', 'contentData', 'instructionsData', 'customFieldsData'],
  mappingName: 'parsedData',
  type: OperationType.addOperationData
}];

export const proceedWithSubmissionCreation: Action = [{
  type: OperationType.action,
  name: 'getParsedSubmissionData'
}, {
  type: OperationType.conditional,
  condition: '{parsedDataWithoutErrors}',
  conditionOperations: [{
    condition: '{isTemplate}',
    conditionOperations: [{
      moduleName: 'App',
      localeProperty: "saveTemplateInProcess",
      type: OperationType.maskModule
    }],
    elseOperations: [{
      moduleName: 'App',
      localeProperty: "saveSubmissionInProcess",
      type: OperationType.maskModule
    }],
    type: OperationType.conditional
  }, {
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    type: OperationType.request,
    data: {
      url: '/submissions/create',
      method: 'post',
      template: {
        bind: {
          params: '{parsedData}'
        }
      },
    },
    mappingName: 'createdSubmissionResponse'
  }, {
    data: {
      template: {
        bind: {
          responseData: '{createdSubmissionResponse}',
          createdSubmission: '{createdSubmissionResponse}'
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }, {
    name: 'createSubmissionPing',
    type: OperationType.action
  }]
}];

export const createSubmissionPing: Action = [{
  condition: '!_.get({createdSubmission}, "response.data.errors")}',
  conditionOperations: [{
    condition: '{createdSubmission} && {createdSubmission.processingFinished}',
    conditionOperations: [{
      actionType: {
        dispatcherId: 'mainDispatcher'
      },
      name: 'proceedWithSaveSubmission',
      type: OperationType.action
    }, {
      dispatcherIds: ['batchPingDispatcher'],
      type: OperationType.unlink
    }],
    elseOperations: [{
      actionType: {
        dispatcherId: "batchPingDispatcher",
        delay: 1000
      },
      data: {
        template: {
          processId: {
            bind: {
              processId: '{createdSubmission.processId}'
            }
          }
        }
      },
      name: 'pingCreateSubmissionRequest',
      type: OperationType.stack
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const pingCreateSubmissionRequest: Action = [{
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  type: OperationType.request,
  data: {
    url: '/submissions/create',
    method: 'post',
    template: {
      headers: {
        bind: {
          'X-Process-Uuid': '{processId.processId}'
        }
      },
      bind: {
        params: '{processId}'
      }
    },
  },
  mappingName: 'createdSubmissionResponse'
}, {
  data: {
    template: {
      bind: {
        responseData: '{createdSubmissionResponse}',
        createdSubmission: '{createdSubmissionResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  items: ['createdSubmission'],
  type: OperationType.syncDispatchersDataItem,
  referenceDispatcherId: 'batchPingDispatcher'
}, {
  name: 'createSubmissionPing',
  type: OperationType.action
}];

export const proceedWithSaveSubmission: Action = [{
  type: OperationType.conditional,
  condition: '{createdSubmission}',
  conditionOperations: [{
    condition: '{isTemplate}',
    conditionOperations: [{
      moduleName: 'App',
      localeProperty: "saveTemplateInProcess",
      type: OperationType.maskModule
    }],
    elseOperations: [{
      moduleName: 'App',
      localeProperty: "saveSubmissionInProcess",
      type: OperationType.maskModule
    }],
    type: OperationType.conditional
  }, {
    data: {
      method: 'post',
      template: {
        bind: {
          url: '"/submissions/" + {createdSubmission.submissionId} + "/save"',
          params: '{autoStart}'
        }
      },
    },
    handleError: true,
    mappingName: 'submissionResponseData',
    type: OperationType.request
  }, {
    type: OperationType.conditional,
    condition: '_.get({submissionResponseData}, "status") !== 200',
    conditionOperations: [{
      name: 'saveSubmissionError',
      type: OperationType.action
    }, {
      moduleName: 'App',
      type: OperationType.unmaskModule
    }],
    elseOperations: [{
      type: OperationType.conditional,
      condition: '{analyze}',
      conditionOperations: [{
        moduleName: 'App',
        localeProperty: 'analyzeSubmission',
        type: OperationType.maskModule
      }, {
        data: {
          template: {
            bind: {
              url: '"/submissions/" + {createdSubmission.submissionId} + "/analyze"'
            }
          }
        },
        handleErrorStatuses: [
          ErrorCodes.BAD_REQUEST,
          ErrorCodes.FORBIDDEN,
          ErrorCodes.INTERNAL_SERVER_ERROR,
          ErrorCodes.NOT_FOUND
        ],
        mappingName: 'analyzeResponse',
        type: OperationType.request
      }, {
        data: {
          template: {
            bind: {
              responseData: '{analyzeResponse}',
            }
          }
        },
        name: 'handleRequestException',
        type: OperationType.action
      }]
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      type: OperationType.action,
      name: 'redirectToSubmissionList'
    }, {
      type: OperationType.conditional,
      condition: '{openSelectSuppliers}',
      conditionOperations: [{
        type: OperationType.addPersistentData,
        data: {
          template: {
            bind: {
              submissionData: '{createdSubmission}',
            }
          }
        },
        persistent: ['submissionData']
      }, {
        name: 'selectSuppliers',
        type: OperationType.action
      }, {
        persistent: ['openSelectSuppliers'],
        type: OperationType.removePersistentData
      }]
    }, {
      persistent: ['submissionData', 'submissionId', 'project', 'createdSubmission', 'submissionMode', 'openSelectSuppliers', 'autoStart', 'analyze'],
      type: OperationType.removePersistentData
    }]
  }]
}];

export const saveSubmissionError: Action = [{
  data: {
    template: {
      bind: {
        errorMessageTitle: '_.get({submissionResponseData},"data.errors[0].message")',
        errorMessageText: '_.get({submissionResponseData},"data.errors[0].description")',
        errorMessageCode: '_.get({submissionResponseData},"data.errors[0].errorCode")'
      }
    }
  },
  persistent: ['errorMessageText', 'errorMessageCode'],
  type: OperationType.addPersistentData
}, {
  warningType: WarningType.error,
  title: 'saveSubmissionError.error',
  placeholders: {
    template: {
      bind: {
        message: '{errorMessageText}',
        title: '{errorMessageTitle}'
      }
    }
  },
  text: 'saveSubmissionError.message',
  className: 'sm confirm-light',
  items: [{
    btnConfig: {
      dock: DockType.bottom,
      fillMode: 'flat',
      pos: Position.end
    },
    btnName: 'saveSubmissionError.close',
    close: false,
    operations: [{
      name: 'saveSubmissionErrorClose',
      type: OperationType.action
    }]
  }, {
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      name: 'saveSubmissionErrorClose',
      type: OperationType.action
    }]
  }],
  type: OperationType.warning
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const saveSubmissionErrorClose: Action = [{
  condition: '{errorMessageCode} === "CORE.ERR.SUB.NOAPPQUOT"',
  conditionOperations: [{
    persistent: ['createdSubmission', 'submissionMode', 'openSelectSuppliers', 'autoStart', 'analyze', 'errorMessageText', 'errorMessageCode'],
    type: OperationType.removePersistentData
  }, {
    name: 'redirectToSubmissionList',
    type: OperationType.action
  }, {
    windowType: WindowType.warning,
    type: OperationType.closeWindow
  }],
  elseOperations: [{
    persistent: ['createdSubmission', 'submissionMode', 'openSelectSuppliers', 'autoStart', 'analyze', 'errorMessageText', 'errorMessageCode'],
    type: OperationType.removePersistentData
  }, {
    windowType: WindowType.warning,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}];

export const resetContentAndCustomFields: Action = [{
  moduleName: 'DropUpload',
  name: 'reset'
}, {
  moduleName: 'CustomFields',
  name: 'reset'
}];

export const updateFilesGridHeight: Action = [{
  moduleName: 'Files',
  name: 'setDynamicSize'
}];

export const getSubmissionMode: Action = [{
  name: 'getMode',
  moduleName: 'SubmissionCrossover',
  mappingName: 'submissionMode',
  type: OperationType.addOperationData
}];

export const getSubmissionData: Action = [{
  name: 'getProjectForSubmission',
  type: OperationType.action
}, {
  type: OperationType.conditional,
  condition: '{submissionMode} !== "EDIT" && {submissionMode} !== "TEMPLATE_EDIT"',
  conditionOperations: [{
    name: 'getTemplatesForSubmission',
    type: OperationType.action
  }]
}, {
  data: {
    template: {
      method: 'get',
      bind: {
        url: '"/submissions/"+ {submissionData.submissionId}'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'submissionData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{submissionData}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'getSubmissionMode',
  type: OperationType.action
}, {
  condition: '{submissionMode}',
  CREATE: [{
    moduleName: 'Create',
    name: 'parseInitData',
    args: ['submissionData'],
    mappingName: 'parsedSubmissionData',
    type: OperationType.addOperationData
  }],
  EDIT: [{
    moduleName: 'Edit',
    name: 'parseInitData',
    args: ['submissionData'],
    mappingName: 'parsedSubmissionData',
    type: OperationType.addOperationData
  }],
  CLONE: [{
    moduleName: 'Clone',
    name: 'parseInitData',
    args: ['submissionData'],
    mappingName: 'parsedSubmissionData',
    type: OperationType.addOperationData
  }],
  TEMPLATE_EDIT: [{
    moduleName: 'TemplateEdit',
    name: 'parseInitData',
    args: ['submissionData'],
    mappingName: 'parsedSubmissionData',
    type: OperationType.addOperationData
  }],
  type: OperationType.switch
}, {
  name: 'getDataByProject',
  data: {
    template: {
      bind: {
        projectId: '{parsedSubmissionData.details.project}'
      }
    }
  },
  type: OperationType.action
}, {
  moduleName: 'Details',
  name: 'setData',
  data: {
    template: {
      bind: {
        details: '{parsedSubmissionData.details}'
      }
    }
  },
  args: ['details', 'afterTemplateChange']
}, {
  name: 'getProjectPolicies',
  type: OperationType.action
}, {
  moduleName: 'Content',
  name: 'setData',
  data: {
    template: {
      bind: {
        content: '{parsedSubmissionData.content}',
        batchInfos: '{parsedSubmissionData.content.batchInfos}',
        partiallyAnalyzed: `_.get({selectedSubmissions},"[0].partiallyAnalyzed")`,
      }
    }
  },
  args: ['content', 'details', 'initializeUserData', 'partiallyAnalyzed', 'afterTemplateChange']
}, {
  type: OperationType.conditional,
  condition: '{batchInfos.length > 1}',
  conditionOperations: [{
    name: 'getBatchesContentData',
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      template: {
        bind: {
          contentFiles: '{content.batchInfos[0].targets}'
        }
      }
    },
    moduleName: 'DropUpload',
    name: 'setExistingFiles',
    args: ['contentFiles', 'details'],
    moduleId: 'fromContent',
    type: OperationType.addOperationData
  }]
}, {
  moduleName: 'Instructions',
  name: 'setData',
  data: {
    template: {
      bind: {
        instructions: '{parsedSubmissionData.instructions}'
      }
    }
  },
  args: ['instructions']
}, {
  data: {
    template: {
      bind: {
        languages: '{initializeUserData.languages}',
        referenceFiles: '{instructions.referenceFiles}'
      }
    }
  },
  moduleName: 'DropUpload',
  name: 'setExistingFiles',
  args: ['referenceFiles', 'details', 'languages'],
  moduleId: 'fromInstructions',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        mediaAssetsNumber: '{parsedSubmissionData.mediaAssetsNumber}'
      }
    }
  },
  moduleName: 'View',
  name: 'setMediaAssetsAndInstructions',
  args: ['mediaAssetsNumber', 'instructions']
}, {
  moduleName: 'CustomFields',
  name: 'setData',
  data: {
    template: {
      bind: {
        customFields: '{parsedSubmissionData.customAttributes}'
      }
    }
  },
  args: ['customFields']
}, {
  moduleName: 'View',
  name: 'takeSubmissionSnapshot'
}];

export const saveSubmission: Action = [{
  name: 'checkSubmissionValidity',
  type: OperationType.action
}, {
  condition: '{isSubmissionValid}',
  conditionOperations: [{
    data: {
      autoStart: {
        autoStart: false
      }
    },
    persistent: ['autoStart'],
    type: OperationType.addPersistentData
  }, {
    name: 'proceedWithSubmissionCreation',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const analyzeSubmission: Action = [{
  name: 'checkSubmissionValidity',
  type: OperationType.action
}, {
  condition: '{isSubmissionValid}',
  conditionOperations: [{
    data: {
      autoStart: {
        autoStart: false
      },
      analyze: true
    },
    persistent: ['autoStart', 'analyze'],
    type: OperationType.addPersistentData
  }, {
    name: 'proceedWithSubmissionCreation',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

/**
 * Click on confirmation dialog on create submission
 */
export const startSubmission: Action = [{
  data: {
    autoStart: {
      autoStart: true
    }
  },
  persistent: ['autoStart'],
  type: OperationType.addPersistentData
}, {
  name: 'proceedWithSubmissionCreation',
  type: OperationType.action
}];

/**
 * Click on confirmation dialog on edit submission
 */
export const startEditSubmission: Action = [{
  name: 'checkSubmissionValidity',
  type: OperationType.action
}, {
  condition: '{isSubmissionValid}',
  conditionOperations: [{
    name: 'saveEditRequest',
    type: OperationType.action
  }, {
    condition: '{editSubmissionCompleted}',
    conditionOperations: [{
      moduleName: 'App',
      localeProperty: 'startSubmissionConfirmInProcess',
      type: OperationType.maskModule
    }, {
      data: {
        template: {
          bind: {
            url: '"/submissions/" + {submissionId} + "/start"',
          }
        }
      },
      handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
      mappingName: 'startSubmissionResponse',
      type: OperationType.request
    }, {
      data: {
        template: {
          bind: {
            responseData: '{startSubmissionResponse}',
          }
        }
      },
      name: 'handleRequestException',
      type: OperationType.action
    }, {
      name: 'redirectToSubmissionList',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }, {
    persistent: ['editSubmissionCompleted'],
    type: OperationType.removePersistentData
  }],
  type: OperationType.conditional
}];

export const startSubmissionRequest: Action = [{
  moduleName: 'App',
  localeProperty: 'startSubmissionConfirmInProcess',
  type: OperationType.maskModule
}, {
  data: {
    template: {
      bind: {
        url: '"/submissions/" + {submissionData.submissionId} + "/start"',
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'startSubmissionResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{startSubmissionResponse}',
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  condition: '{route() === "view/submission"} || {route().startsWith("view/submission/")}',
  conditionOperations: [{
    data: {
      path: '/view/submissionList'
    },
    type: OperationType.redirect
  }],
  elseOperations: [{
    name: 'refreshMainGridOnCurrentPosition',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const cancelOnHoldSubmission: Action = [{
  placeholders: {
    template: {
      bind: {
        submissionName: '{submissionData.submissionName}'
      }
    },
  },
  warningType: WarningType.info,
  title: 'cancelOnHoldSubmission.cancelSubmission',
  text: 'cancelOnHoldSubmission.text',
  type: OperationType.warning,
  className: 'sm confirm-light',
  closable: false,
  items: [{
    btnName: 'cancelOnHoldSubmission.back',
    operations: [],
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'cancelOnHoldSubmission.cancelSubmission',
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    },
    operations: [{
      name: 'cancelAllSubmission',
      type: OperationType.action
    }],
  }]
}];

export const cancelSubmission: Action = [{
  data: {
    template: {
      bind: {
        submissionName: '{submissionData.submissionName}'
      }
    }
  },
  persistent: ['submissionName'],
  type: OperationType.addPersistentData
}, {
  data: {
    template: {
      bind: {
        submissionId: '{submissionData.submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  name: 'CancelSubmissionSelectedItems',
  type: OperationType.action
}];

export const cancelAllSubmission: Action = [{
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    template: {
      bind: {
        url: '"/submissions/cancel/" + {submissionId}'
      }
    }
  },
  mappingName: 'cancelResponseData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{cancelResponseData}'
      }
    }
  },
  type: OperationType.data
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  persistent: ['editSubmissionCompleted'],
  type: OperationType.removePersistentData
}, {
  name: 'refreshMainGridOnCurrentPosition',
  type: OperationType.action
}]

export const openWordCountFromDrawer: Action = [{
  data: {
    template: {
      bind: {
        submission: '{selectedSubmissions[0]}'
      }
    }
  },
  type: OperationType.data
}, {
  name: 'openWordCount',
  type: OperationType.action
}];

export const getDownloadAnalysisPolicy: Action = [{
  data: {
    template: {
      downloadAnalysisPolicy: 'hasDownloadAnalysis'
    }
  },
  moduleName: 'Policies',
  args: ['downloadAnalysisPolicy'],
  name: 'getSystemPolicy',
  mappingName: 'hasDownloadAnalysis',
  type: OperationType.addOperationData
}];

export const openWordCount: Action = [{
  data: {
    template: {
      bind: {
        submissionId: "{submission.submissionId}",
        submissionName: "{submission.submissionName}"
      }
    }
  },
  persistent: ['submissionId'],
  type: OperationType.addPersistentData
}, {
  data: {
    asSubName: true,
    asSubId: true,
    notificationText: 'wordCount.footerNotificationText',
    notificationType: 'warning',
    notificationIcon: 'warning-triangle'
  },
  type: OperationType.data
}, {
  name: 'getDownloadAnalysisPolicy',
  type: OperationType.action
}, {
  className: 'xl word-count with-custom-header',
  children: [{
    render: WordCount,
    propArgs: ['wordCountData', 'submissionId', 'submission', 'preExpandJob', 'groupBy']
  }],
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    operations: [],
    btnName: 'wordCount.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      data: {
        template: {
          params: {
            downloadTmStatistics: true
          }
        }
      },
      name: 'pingUntilDownloadIsReady',
      type: OperationType.action
    }],
    btnName: 'wordCount.download',
    btnConfig: {
      template: {
        bind: {
          hidden: '!{hasDownloadAnalysis}'
        }
      },
      accessibility: {
        ariaLabel: '',
        iconAriaHidden: true
      },
      themeColor: 'primary',
      pos: Position.end,
    }
  }],
  title: 'wordCount.title',
  type: OperationType.dialog
}, {
  condition: '{groupBy} === "languages"',
  conditionOperations: [{
    name: 'getWordCountDataLanguageGrouping',
    type: OperationType.action
  }],
  elseOperations: [{
    name: 'getWordCountDataBatchGrouping',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const wordCountGetJobFiles: Action = [{
  data: {
    method: 'post',
    template: {
      bind: {
        url: '"/submissions/"+{submissionId}+"/documents/wordCount"',
        params: '{wordCountParams}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'jobFilesResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{jobFilesResponse}',
        jobFiles: '{jobFilesResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'loadJobWithFiles',
  moduleName: 'WordCount',
  args: ['jobFiles']
}];

export const getWordCountDataLanguageGrouping: Action = [{
  data: {
    method: 'get',
    template: {
      bind: {
        url: `"/submissions/"+{submissionId}+"/wordCount"`
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'wordCountResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{wordCountResponse}',
        wordCountData: '{wordCountResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'loadWordCountData',
  type: OperationType.action
}];

export const getWordCountDataBatchGrouping: Action = [{
  data: {
    method: 'get',
    template: {
      bind: {
        url: `"/submissions/"+{submissionId}+"/batch/wordCount"`
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'wordCountResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{wordCountResponse}',
        wordCountData: '{wordCountResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'loadWordCountData',
  type: OperationType.action
}];

export const loadWordCountData: Action = [{
  moduleName: 'WordCount',
  name: 'loadData',
  args: ['wordCountData']
}];

export const editSubmission: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    template: {
      bind: {
        path: '({submissionMode === "EDIT" ? "/view/submission/" : "/view/template/"}) + {submissionData.submissionId}'
      }
    }
  },
  moduleName: 'App',
  type: OperationType.redirect
}, {
  moduleName: 'SubmissionCrossover',
  name: 'setMode',
  args: ['submissionMode'],
  waitForModule: true
}, {
  name: 'getSubmissionData',
  type: OperationType.action
}, {
  name: 'isClaimScopeActive',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const saveEditRequest: Action = [{
  name: 'getParsedSubmissionData',
  type: OperationType.action
}, {
  condition: '{parsedDataWithoutErrors}',
  conditionOperations: [{
    data: {
      method: 'put',
      template: {
        bind: {
          url: '"/submissions/" + {submissionId} + "/edit"',
          params: '{parsedData}'
        }
      },
    },
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    mappingName: 'editSubmissionResponse',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{editSubmissionResponse}',
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }, {
    condition: '{analyze}',
    conditionOperations: [{
      data: {
        template: {
          bind: {
            url: '"/submissions/" + {submissionId} + "/analyze"'
          }
        }
      },
      handleErrorStatuses: [
        ErrorCodes.BAD_REQUEST,
        ErrorCodes.FORBIDDEN,
        ErrorCodes.INTERNAL_SERVER_ERROR,
        ErrorCodes.NOT_FOUND
      ],
      mappingName: 'analyzeResponse',
      type: OperationType.request
    }, {
      data: {
        template: {
          bind: {
            responseData: '{analyzeResponse}',
          }
        }
      },
      name: 'handleRequestException',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }, {
    condition: '{openSelectSuppliers}',
    conditionOperations: [{
      data: {
        update: {
          parsedData: {
            bind: {
              submissionId: '{submissionId}'
            }
          }
        }
      },
      type: OperationType.data
    }, {
      data: {
        template: {
          bind: {
            submissionData: '{parsedData}'
          }
        }
      },
      persistent: ['submissionData'],
      type: OperationType.addPersistentData
    }],
    type: OperationType.conditional
  }, {
    data: {
      editSubmissionCompleted: true
    },
    persistent: ['editSubmissionCompleted'],
    type: OperationType.addPersistentData
  }],
  type: OperationType.conditional,
}];

export const saveEditSubmission: Action = [{
  name: 'checkSubmissionValidity',
  type: OperationType.action
}, {
  condition: '{isSubmissionValid}',
  conditionOperations: [{
    name: 'saveEditRequest',
    type: OperationType.action
  }, {
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }, {
    condition: '{editSubmissionCompleted}',
    conditionOperations: [{
      name: 'redirectToSubmissionList',
      type: OperationType.action
    }, {
      condition: '{mainGridFilter} && !_.isEmpty({mainGridFilter})',
      conditionOperations: [{
        moduleName: 'SearchBar',
        name: 'addFilterToState',
        args: ['mainGridFilter']
      }],
      type: OperationType.conditional
    }],
    type: OperationType.conditional
  }, {
    persistent: ['editSubmissionCompleted'],
    type: OperationType.removePersistentData
  }, {
    type: OperationType.conditional,
    condition: '{openSelectSuppliers}',
    conditionOperations: [{
      name: 'selectSuppliers',
      type: OperationType.action
    }, {
      persistent: ['openSelectSuppliers'],
      type: OperationType.removePersistentData
    }],
    elseOperations: [{
      persistent: ['openSelectSuppliers'],
      type: OperationType.removePersistentData
    }]
  }, {
    persistent: ['submissionData', 'submissionId', 'project'],
    type: OperationType.removePersistentData
  }],
  elseOperations: [{
    persistent: ['openSelectSuppliers'],
    type: OperationType.removePersistentData
  }],
  type: OperationType.conditional
}];

//todo check why redirect send params in filters request
export const redirectToSubmissionList: Action = [{
  condition: '{isTemplate}',
  conditionOperations: [{
    data: {
      path: '/view/templates'
    },
    moduleName: 'App',
    type: OperationType.redirect
  }, {
    name: 'reloadTemplates',
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      path: '/view/submissionList'
    },
    moduleName: 'App',
    type: OperationType.redirect
  }, {
    name: 'reloadSubmissionList',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const resetProjectRelatedDataAndSetNew: Action = [{
  moduleName: 'Content',
  name: 'resetProjectRelatedData'
}, {
  moduleName: 'Details',
  args: ['projectId'],
  name: 'resetProjectRelatedData'
}, {
  moduleName: 'CustomFields',
  name: 'reset'
}, {
  moduleName: 'View',
  name: 'hideCustomFields'
}, {
  name: 'enableUpload',
  args: ['projectId'],
  type: OperationType.action
}, {
  condition: '{projectId}',
  conditionOperations: [{
    name: 'getProjectPolicies',
    type: OperationType.action
  }, {
    name: 'getDataByProject',
    type: OperationType.action
  }, {
    name: 'preselectSubmissionData',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const workflowRequest: Action = [{
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/projects/" + {projectId} +"/workflows/" + {workflowId}',
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'workflowDetailsRequest',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{workflowDetailsRequest}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}];

/**
 * Checks if policy is Policies cache, if not requests the policies form rest
 */
export const getProjectPolicies: Action = [{
  moduleName: 'Policies',
  name: 'checkPolicyCache',
  args: ['projectId'],
  mappingName: 'projectIsCached',
  type: OperationType.addOperationData
}, {
  condition: '!{projectIsCached}',
  conditionOperations: [{
    data: {
      method: 'get',
      template: {
        bind: {
          url: '"/userInfo/contextRoleInfo/contextId/" + {projectId}'
        }
      }
    },
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    mappingName: 'projectPoliciesResponse',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{projectPoliciesResponse}',
          projectPolicies: '{projectPoliciesResponse}'
        }
      }
    },
    name: 'handleRequestException',
    type: OperationType.action
  }, {
    moduleName: 'Policies',
    args: ['projectPolicies', 'projectId'],
    name: 'setProjectPolicies'
  }],
  type: OperationType.conditional
}];

export const cloneSubmissionRequest: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  data: {
    path: '/view/submission'
  },
  moduleName: 'App',
  type: OperationType.redirect
}, {
  data: {
    submissionMode: 'CLONE'
  },
  moduleName: 'SubmissionCrossover',
  name: 'setMode',
  args: ['submissionMode'],
  waitForModule: true
}, {
  name: 'getSubmissionData',
  type: OperationType.action
}, {
  name: 'isClaimScopeActive',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const CancelSubmissionSelectedItems: Action = [{
  data: {
    filesCount: 0,
    selectedFilesLabelTranslate: 'cancelSubmission.selectedFilesInfo',
  },
  persistent: ['submissionId'],
  type: OperationType.addPersistentData
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/cancel/" + {submissionId}'
      }
    }
  },
  mappingName: 'cancelSubmissionResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{cancelSubmissionResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    asSubId: true,
    switch1Label: 'switchLabels.languageLabel',
    switch1Action: 'setSubByLanguage',
    switch2Label: 'switchLabels.batchLabel',
    switch2Action: 'setSubByBatch',
    template: {
      asSubName: true,
      bind: {
        cancelSubmissionData: '{cancelSubmissionResponse}'
      }
    }
  },
  type: OperationType.data
}, {
  children: [{
    render: CancelSelectedOnly,
    propArgs: ['cancelSubmissionData',]
  }],
  className: 'lg cancel-selected-items with-custom-header',
  items: [{
    btnName: 'submissionName',
    btnConfig: {
      args: ['submissionId', 'submissionName', 'asSubName'],
      customTagType: CustomTagType.label,
      dock: DockType.top,
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'cancelSubmission.close',
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      persistent: ['submissionId'],
      type: OperationType.removePersistentData
    }],
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }, {
    btnName: 'cancelSubmission.back',
    operations: [{
      name: 'switchBackToTreeList',
      moduleName: 'CancelSelectedOnly'
    }],
    close: false,
    btnConfig: {
      hidden: true,
      fillMode: 'flat',
      pos: Position.start
    }
  }, {
    btnName: 'selectedFilesLabel',
    operations: [],
    btnConfig: {
      args: ['selectedFilesLabelTranslate', 'filesCount'],
      customTagType: CustomTagType.counter,
      pos: Position.start
    }
  }, {
    btnName: 'cancelSubmission.selectedItems',
    close: false,
    operations: [{
      name: 'onCancel',
      moduleName: 'CancelSelectedOnly',
      mappingName: 'cancelSubmissionJsonData',
      type: OperationType.addOperationData
    }, {
      persistent: ['cancelSubmissionJsonData'],
      type: OperationType.addPersistentData
    }, {
      name: 'getNumberOfSelectedFiles',
      moduleName: 'CancelSelectedOnly',
      mappingName: 'filesCount',
      type: OperationType.addOperationData
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      name: 'cancelSubmissionConfirmationDialog',
      type: OperationType.action
    }],
    btnConfig: {
      disabled: true,
      pos: Position.end,
      themeColor: 'primary'
    }
  }, {
    btnName: 'cancelSubmission.cancelAll',
    close: false,
    operations: [{
      name: 'getTotalFilesCount',
      moduleName: 'CancelSelectedOnly',
      mappingName: 'filesCount',
      type: OperationType.addOperationData
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      name: 'cancelSubmissionConfirmationDialog',
      type: OperationType.action
    }],
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    }
  }],
  title: 'cancelSubmission.title',
  type: OperationType.dialog
}];

export const setSubByLanguage: Action = [{
  data: {
    activeTabToogler: true
  },
  moduleName: 'CancelSelectedOnly',
  name: 'setLanguagesTabActive',
  args: ['activeTabToogler']
}];

export const setSubByBatch: Action = [{
  data: {
    activeTabToogler: false
  },
  moduleName: 'CancelSelectedOnly',
  name: 'setLanguagesTabActive',
  args: ['activeTabToogler']
}];

export const updateCancelSubmissionFooter: Action = [{
  data: {
    selectedFilesLabelTranslate: 'cancelSubmission.selectedFilesInfo'
  },
  buttons: [{
    name: 'cancelSubmission.selectedItems',
    disabled: '!{filesCount}'
  }, {
    name: 'cancelSubmission.close',
    hidden: '{filesGridDisplayed}'
  }, {
    name: 'cancelSubmission.back',
    hidden: '!{filesGridDisplayed}'
  }],
  customTags: [{
    name: 'selectedFilesLabel',
    args: ['selectedFilesLabelTranslate', 'filesCount']
  }],
  type: OperationType.updateDialog
}];

export const cancelSubmissionConfirmationDialog: Action = [{
  placeholders: {
    template: {
      bind: {
        filesCount: '{filesCount}'
      }
    },
    className: 'tp-text-semibold'
  },
  text: 'cancelSubmission.confirmCancellationText',
  items: [{
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }, {
      name: 'onCancelSubmissionConfirm',
      type: OperationType.action
    }],
    close: false,
    btnName: 'cancelSubmission.confirmCancellationButton',
    btnConfig: {
      themeColor: 'error',
      pos: Position.end
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      type: OperationType.removePersistentData,
      persistent: ['cancelSubmissionJsonData', 'submissionId']
    }]
  }],
  className: 'sm',
  title: 'cancelSubmission.confirmCancellationTitle',
  type: OperationType.dialog
}];

export const onCancelSubmissionConfirm: Action = [{
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    template: {
      bind: {
        url: '"/submissions/cancel/" + {submissionId}',
        params: '{cancelSubmissionJsonData}'
      }
    }
  },
  mappingName: 'cancelSubmissionResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{cancelSubmissionResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'refreshMainGridOnCurrentPosition',
  type: OperationType.action
}, {
  persistent: ['submissionId', 'cancelSubmissionJsonData'],
  type: OperationType.removePersistentData
}];

export const selectSuppliersSubmissionAction: Action = [{
  persistent: ['submissionMode', 'project'],
  type: OperationType.addPersistentData
}, {
  name: 'checkSubmissionValidity',
  type: OperationType.action
}, {
  condition: '{isSubmissionValid}',
  conditionOperations: [{
    data: {
      openSelectSuppliers: true
    },
    persistent: ['openSelectSuppliers'],
    type: OperationType.addPersistentData
  }, {
    condition: '{submissionMode} === "EDIT"',
    conditionOperations: [{
      name: 'saveEditSubmission',
      type: OperationType.action
    }],
    elseOperations: [{
      name: 'saveSubmission',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const startSubmissionDialog: Action = [{
  persistent: ['submissionMode', 'project'],
  type: OperationType.addPersistentData
}, {
  moduleName: 'Content',
  name: 'checkHumanSteps',
  mappingName: 'humanSteps',
  type: OperationType.addOperationData
}, {
  name: 'checkSubmissionValidity',
  type: OperationType.action
}, {
  condition: '{isSubmissionValid}',
  conditionOperations: [{
    type: OperationType.conditional,
    condition: '{submissionMode} === "EDIT"',
    conditionOperations: [{
      type: OperationType.addPersistentData,
      persistent: ['submissionId']
    }]
  }, {
    data: {
      template: {
        selectVendorsButtonsDialogPolicy: 'hasSelectVendorsButtonsDialogPolicy'
      }
    },
    moduleName: 'Policies',
    args: ['project', 'selectVendorsButtonsDialogPolicy'],
    name: 'getProjectPolicy',
    mappingName: 'hideByPolicy',
    type: OperationType.addOperationData
  }, {
    condition: '{humanSteps}',
    conditionOperations: [{
      items: [{
        btnName: 'startSubmissionConfirm.goBack',
        operations: [{
          windowType: WindowType.dialog,
          type: OperationType.closeWindow
        }],
        btnConfig: {
          pos: Position.end,
          fillMode: 'flat'
        }
      }, {
        btnName: 'startSubmissionConfirm.selectSuppliers',
        operations: [{
          data: {
            openSelectSuppliers: true
          },
          persistent: ['openSelectSuppliers'],
          type: OperationType.addPersistentData
        }, {
          condition: '{submissionMode} === "EDIT"',
          conditionOperations: [{
            name: 'saveEditSubmission',
            type: OperationType.action
          }],
          elseOperations: [{
            name: 'saveSubmission',
            type: OperationType.action
          }],
          type: OperationType.conditional
        }],
        btnConfig: {
          pos: Position.end,
          themeColor: 'dark',
          template: {
            bind: {
              hidden: '!{hideByPolicy}',
            },
          }
        },
        close: false
      }, {
        btnName: 'startSubmissionConfirm.start',
        operations: [{
          condition: '{submissionMode} === "EDIT"',
          conditionOperations: [{
            windowType: WindowType.dialog,
            type: OperationType.closeWindow
          }, {
            name: 'startEditSubmission',
            type: OperationType.action
          }],
          elseOperations: [{
            name: 'startSubmission',
            type: OperationType.action
          }],
          type: OperationType.conditional
        }],
        btnConfig: {
          pos: Position.end,
          themeColor: 'primary'
        }
      }],
      text: 'startSubmissionConfirm.text',
      title: 'startSubmissionConfirm.title',
      className: 'sm start-submission',
      type: OperationType.dialog
    }],
    elseOperations: [{
      name: 'startSubmission',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const removeTempFile: Action = [{
  data: {
    method: 'post',
    url: '/submissions/delete/temporary',
    template: {
      bind: {
        params: '{removeFileParams}'
      }
    }
  },
  type: OperationType.request
}];

export const submissionTargetLanguageChange: Action = [{
  moduleName: 'DropUpload',
  moduleId: 'fromInstructions',
  name: 'setTargetLanguages',
  args: ['selectedTargetLanguages']
}, {
  name: 'simpleSubmissionTargetLanguageChange',
  type: OperationType.action
}];

export const simpleSubmissionTargetLanguageChange: Action = [{
  condition: '({submissionMode} === "EDIT" || {submissionMode} === "TEMPLATE_EDIT")',
  conditionOperations: [{
    moduleName: 'Content',
    name: 'changeSimpleSubmissionTargetLanguageInfos',
    args: ['selectedTargetLanguages']
  }],
  type: OperationType.conditional
}];

export const fetchTranslationMemories: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: '_.get({initializeUserData}, "applicationInfo.tptEnabled") ? "/projects/" + {projectId} + "/paClient/" + {paClientId} + "/tms" : "/projects/" + {projectId} + "/tms"'
      },
      params: {
        bind: {
          sourceLanguage: '{sourceLanguage}'
        }
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'translationMemoriesResponse',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{translationMemoriesResponse}',
        translationMemories: '{translationMemoriesResponse}'
      }
    }
  },
  name: 'handleRequestException',
  type: OperationType.action
}, {
  condition: '{submissionMode === "EDIT"}',
  conditionOperations: [{
    data: {
      template: {
        method: 'get',
        bind: {
          url: '"/submissions/" + {selectedSubmissions[0].submissionId} + "/tms"'
        }
      }
    },
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    mappingName: 'selectedTranslationMemoriesResponse',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{selectedTranslationMemoriesResponse}',
          selectedTranslationMemories: '{selectedTranslationMemoriesResponse}'
        }
      }
    },
    name: 'handleRequestException',
    args: ['responseData'],
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const openTM: Action = [{
  moduleName: 'DropUpload',
  name: 'getTargetFormat',
  moduleId: '{moduleId}',
  evaluate: true,
  mappingName: 'targetFormat',
  type: OperationType.addOperationData
}, {
  persistent: ['targetFormat'],
  type: OperationType.addPersistentData
}, {
  condition: '{targetFormat}',
  conditionOperations: [{
    moduleName: 'AbstractSection',
    evaluate: true,
    moduleId: '{moduleId}',
    name: 'setExtra',
    args: ['type']
  }],
  elseOperations: [{
    className: 'sm footer-centered',
    warningType: WarningType.warning,
    text: 'tmTargetFormatError.text',
    title: 'tmTargetFormatError.title',
    type: OperationType.warning,
    items: [{
      operations: [{
        windowType: WindowType.warning,
        type: OperationType.closeWindow
      }],
      btnName: 'tmTargetFormatError.close',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }]
  }],
  type: OperationType.conditional
}];

export const openTMConfiguration: Action = [{
  condition: '{hasGlossary}',
  conditionOperations: [{
    data: {
      template: {
        method: 'get',
        bind: {
          url: '_.get({initializeUserData}, "applicationInfo.tptEnabled") ? "/projects/" + {projectId} + "/paClient/" + {paClientId} + "/glossaries" : "/projects/" + {projectId} + "/glossaries"'
        },
        params: {
          bind: {
            sourceLanguage: '{sourceLanguage}',
            targetLanguage: '{tmConfigurationData.targetLanguage}'
          }
        }
      }
    },
    handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
    mappingName: 'glossariesResponse',
    type: OperationType.request
  }, {
    data: {
      template: {
        bind: {
          responseData: '{glossariesResponse}',
          glossaries: '{glossariesResponse}'
        }
      }
    },
    name: 'handleRequestException',
    args: ['responseData'],
    type: OperationType.action
  }],
  type: OperationType.conditional
}, {
  name: 'fetchTranslationMemories',
  type: OperationType.action
}, {
  placeholders: {
    template: {
      bind: {
        targetLanguageDisplayName: '{tmConfigurationData.targetLanguageDisplayName}',
      }
    }
  },
  children: [{
    render: TmConfiguration,
    propArgs: ['translationMemories', 'glossaries', 'tmConfigurationData']
  }],
  className: 'sm footer-centered',
  items: [{
    operations: [],
    btnName: 'tmConfiguration.close',
    btnConfig: {
      fillMode: 'outline',
      pos: Position.end
    }
  }],
  title: 'tmConfiguration.title',
  type: OperationType.dialog
}];

export const closeExtra: Action = [{
  moduleName: 'AbstractSection',
  name: 'closeExtra',
  moduleId: '{moduleId}',
  evaluate: true
}];

export const getTranslationMemories: Action = [{
  name: 'fetchTranslationMemories',
  type: OperationType.action
}, {
  moduleName: 'TranslationMemories',
  name: 'setTM',
  args: ['translationMemories', 'selectedTranslationMemories', 'targetFormat']
}, {
  persistent: ['targetFormat'],
  type: OperationType.removePersistentData
}];

export const openTemplateDescription: Action = [{
  children: [{
    render: TemplateDescription,
    propArgs: ['templateDescription']
  }],
  className: 'sm templateDescription',
  items: [{
    operations: [{
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    btnName: 'templateDescription.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'TemplateDescription',
      name: 'getValue',
      mappingName: 'templateDescription',
      type: OperationType.addOperationData
    }, {
      moduleName: 'Details',
      name: 'setTemplateDescription',
      args: ['templateDescription']
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    close: false,
    btnName: 'templateDescription.save',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }],
  title: 'templateDescription.title',
  type: OperationType.dialog
}];

export const editTemplate: Action = [{
  data: {
    submissionMode: 'TEMPLATE_EDIT'
  },
  type: OperationType.data
}, {
  name: 'editSubmission',
  type: OperationType.action
}];

export const updateProgressesToUnzippedFiles: Action = [{
  independent: true,
  args: ['progresses'],
  moduleName: 'ProgressBar',
  name: 'updateProgress',
  executeType: 'visible'
}];

export const checkForChangesBeforeRedirect: Action = [{
  name: 'getSubmissionMode',
  type: OperationType.action
}, {
  condition: '{submissionMode} === "EDIT"',
  conditionOperations: [{
    name: 'getDataForEdit',
    type: OperationType.action
  }],
  elseOperations: [{
    data: {
      parsedData: {}
    },
    type: OperationType.data
  }],
  type: OperationType.conditional
}, {
  condition: '{route() === "view/submission"} || {route().startsWith("view/submission/")} || {route() === "view/template"} || {route().startsWith("view/template/")} ',
  conditionOperations: [{
    type: OperationType.addOperationData,
    name: 'isDataChanged',
    args: ['parsedData'],
    moduleName: 'View',
    mappingName: 'dataChanged'
  }],
  type: OperationType.conditional
}, {
  type: OperationType.conditional,
  condition: '{dataChanged}',
  conditionOperations: [{
    condition: '{leaveAction} === "goBack"',
    conditionOperations: [{
      persistent: ['leaveAction'],
      type: OperationType.addPersistentData
    }],
    elseOperations: [{
      type: OperationType.addPersistentData,
      persistent: ['path', 'leaveAction']
    }],
    type: OperationType.conditional
  }, {
    type: OperationType.action,
    name: 'openChangeRouteWarningDialog'
  }],
  elseOperations: [{
    condition: '{leaveAction} === "goBack"',
    conditionOperations: [{
      name: 'goBack',
      moduleName: 'SubmissionCrossover'
    }],
    elseOperations: [{
      name: 'handleRedirect',
      type: OperationType.action
    }],
    type: OperationType.conditional
  }]
}];

export const handleRedirect: Action = [{
  condition: '{leaveAction}',
  switchToAqua: [{
    name: 'switchToAqua',
    moduleName: 'Viewport'
  }],
  tableau: [{
    name: 'openTableauURL',
    moduleName: 'App'
  }],
  safConnect: [{
    name: 'openSafApp',
    moduleName: 'App',
    args: ['leaveAction']
  }],
  safTerminology: [{
    name: 'openSafApp',
    moduleName: 'App',
    args: ['leaveAction']
  }],
  safTM: [{
    name: 'openSafApp',
    moduleName: 'App',
    args: ['leaveAction']
  }],
  redirect: [{
    type: OperationType.action,
    name: 'reloadPathPD'
  }],
  type: OperationType.switch
}];

export const openChangeRouteWarningDialog: Action = [{
  name: 'getSubmissionMode',
  type: OperationType.action
}, {
  name: 'getModuleName',
  moduleName: 'SubmissionCrossover',
  mappingName: 'currentModuleName',
  type: OperationType.addOperationData
}, {
  name: 'getDialogText',
  evaluate: true,
  moduleName: '{currentModuleName}',
  mappingName: 'dialogText',
  type: OperationType.addOperationData
}, {
  placeholders: {
    template: {
      bind: {
        title: '{dialogText.title}',
        text: '{dialogText.text}'
      }
    }
  },

  type: OperationType.warning,
  className: 'sm confirm-light',
  text: 'exitSubmission.text',
  title: 'exitSubmission.title',
  items: [{
    btnName: 'common.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: [{
      type: OperationType.removePersistentData,
      persistent: ['path', 'leaveAction']
    }]
  }, {
    btnName: 'ESCAPE',
    operations: [{
      type: OperationType.removePersistentData,
      persistent: ['path', 'leaveAction']
    }]
  }, {
    btnName: 'common.exit',
    btnConfig: {
      pos: Position.end,
      themeColor: 'error'
    },
    operations: [{
      condition: '{leaveAction} === "goBack"',
      conditionOperations: [{
        name: 'goBack',
        moduleName: 'SubmissionCrossover'
      }],
      elseOperations: [{
        name: 'handleRedirect',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }, {
      type: OperationType.conditional,
      condition: '{path}',
      conditionOperations: [{
        name: 'handleRedirect',
        type: OperationType.action
      }]
    }, {
      type: OperationType.removePersistentData,
      persistent: ['path', 'leaveAction']
    }]
  }]
}];

export const filesChanged: Action = [{
  data: {
    template: {
      filesChanged: true
    }
  },
  persistent: ['filesChanged'],
  type: OperationType.addPersistentData
}];

export const multiBatchClosePrompt: Action = [{
  moduleName: 'MultiBatchUpload',
  name: 'areThereUnsavedChanges',
  args: ['filesChanged'],
  type: OperationType.addOperationData
}, {
  condition: '{areThereUnsavedChanges}',
  conditionOperations: [{
    type: OperationType.warning,
    className: 'sm confirm-light',
    text: 'cancelBatchesPrompt.text',
    title: 'cancelBatchesPrompt.title',
    items: [{
      btnName: 'cancelBatchesPrompt.no',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      },
      operations: []
    }, {
      btnName: 'cancelBatchesPrompt.yes',
      btnConfig: {
        pos: Position.end,
        themeColor: 'error'
      },
      operations: [{
        persistent: ['filesChanged'],
        type: OperationType.removePersistentData
      }, {
        windowType: WindowType.dialog,
        type: OperationType.closeWindow
      }]
    }]
  }],
  elseOperations: [{
    persistent: ['filesChanged'],
    type: OperationType.removePersistentData
  }, {
    windowType: WindowType.dialog,
    type: OperationType.closeWindow
  }],
  type: OperationType.conditional
}];

export const openMultiBatch: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  moduleName: 'Details',
  name: 'getTargetLanguage',
  mappingName: 'targetLanguageData',
  type: OperationType.addOperationData
}, {
  title: 'multiBatchUpload.title',
  className: '{dialogSize}',
  children: [{
    render: MultiBatchUpload,
    propArgs: [
      'batchInfos',
      'deletedBatches',
      'dontAddEmptyBatch',
      'focusTarget',
      'paClient',
      'partiallyAnalyzed',
      'project',
      'projectFileFormats',
      'projectPolicies',
      'submissionDueDate',
      'submissionMode',
      'submissionStarted',
      'submissionStatus',
      'sourceLanguage',
      'targetLanguageData',
      'workflows',
      'submissionId',
      'hasHumanSteps'
    ]
  }],
  items: [{
    btnName: 'multiBatchUpload.close',
    close: false,
    operations: [{
      name: 'multiBatchClosePrompt',
      type: OperationType.action
    }],
    btnConfig: {
      pos: Position.end,
      fillMode: 'flat'
    }
  }, {
    btnName: 'multiBatchUpload.save',
    operations: [{
      moduleName: 'MultiBatchUpload',
      name: 'saveBatches'
    }],
    close: false,
    btnConfig: {
      pos: Position.end,
      template: {
        bind: {
          disabled: '{uploadIsInProgress}'
        }
      },
      themeColor: 'primary'
    }
  }, {
    btnName: 'ESCAPE',
    close: false,
    operations: [{
      name: 'multiBatchClosePrompt',
      type: OperationType.action
    }]
  }],
  type: OperationType.dialog
}, {
  waitForModule: true,
  condition: '({batchInfos}.length > 1)',
  conditionOperations: [{
    moduleName: 'MultiBatchUpload',
    name: 'setData',
    args: ['batchInfos']
  }],
  elseOperations: [{
    waitForModule: true,
    moduleName: 'DropUpload',
    moduleId: 'fromContent',
    name: 'getSubmissionFolder',
    mappingName: 'submissionFolder',
    type: OperationType.addOperationData
  }, {
    moduleName: 'MultiBatchUpload',
    name: 'setData',
    args: ['batchInfos', 'simpleBatchData', 'submissionFolder']
  }],
  type: OperationType.conditional
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const openMultiBatchWithFocus: Action = [{
  moduleName: 'Content',
  name: 'getMultiBatchDialogConfiguration',
  mappingName: 'configData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        batchInfos: '{configData.batchInfos}',
        dialogSize: '{configData.dialogSize}',
        dontAddEmptyBatch: '{configData.dontAddEmptyBatch}',
        hasHumanSteps: '{configData.hasHumanSteps}',
        partiallyAnalyzed: '{configData.partiallyAnalyzed}',
        project: '{configData.project}',
        projectFileFormats: '{configData.projectFileFormats}',
        projectPolicies: '{configData.projectPolicies}',
        submissionDueDate: '{configData.submissionDueDate}',
        submissionMode: '{configData.submissionMode}',
        submissionStarted: '{configData.submissionStarted}',
        submissionStatus: '{configData.submissionStatus}',
        sourceLanguage: '{configData.sourceLanguage}',
        targetLanguageData: '{configData.targetLanguageData}',
        workflows: '{configData.workflows}',
        submissionId: '{configData.submissionId}'
      }
    }
  },
  type: OperationType.data
}, {
  name: 'openMultiBatch',
  type: OperationType.action
}, {
  waitForModule: true,
  moduleName: 'MultiBatchUpload',
  name: 'scrollToEl',
  args: ['focusTarget']
}];

export const updateState: Action = [{
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{moduleId}',
  name: 'updateStateAndContinueUpload',
  args: ['uploadedFiles', 'submissionFolder']
}];

export const setExistingFiles: Action = [{
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{moduleId}',
  name: 'setExistingFiles',
  args: ['targets', 'details']
}];

export const collectData: Action = [{
  moduleName: 'AbstractSection',
  evaluate: true,
  moduleId: '{moduleId}',
  name: 'getValidation',
  mappingName: 'sectionValidation',
  type: OperationType.addOperationData
}, {
  moduleName: 'MultiBatchUpload',
  name: 'storeValidationData',
  mappingName: 'validation',
  args: ['sectionValidation', 'all'],
  type: OperationType.addOperationData
}, {
  condition: '!{isTemplate}',
  conditionOperations: [{
    moduleName: 'DropUpload',
    evaluate: true,
    moduleId: '{moduleId}',
    name: 'getData',
    mappingName: 'data',
    type: OperationType.addOperationData
  }],
  type: OperationType.conditional
}, {
  moduleName: 'MultiBatchUpload',
  name: 'storeData',
  mappingName: 'batchData',
  args: ['data', 'moduleId', 'all'],
  type: OperationType.addOperationData
}, {
  condition: '{all}',
  conditionOperations: [{
    condition: '{validation}',
    conditionOperations: [{
      moduleName: 'Content',
      name: 'setBatchInfosData',
      args: ['batchData']
    }, {
      condition: '{batchData.batchInfos.length === 1}',
      conditionOperations: [{
        data: {
          dropUploadModuleId: 'MultiBatchUpload_0'
        },
        name: 'appendDeletedSubmissionFiles',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }, {
      data: {
        template: {
          bind: {
            batchInfos: '{batchData.batchInfos}',
            submissionDueDate: '{batchData.submissionDueDate}'
          }
        }
      },
      type: OperationType.data
    }, {
      condition: '{route() === "view/submission"}',
      conditionOperations: [{
        moduleName: 'App',
        name: 'getInitializeUserData',
        mappingName: 'initializeUserData',
        type: OperationType.addOperationData
      }, {
        moduleName: 'Content',
        name: 'setInitialUserData',
        args: ['initializeUserData']
      }],
      type: OperationType.conditional
    }, {
      condition: '{batchInfos}.length > 1',
      conditionOperations: [{
        name: 'getBatchesContentData',
        type: OperationType.action
      }],
      type: OperationType.conditional
    }, {
      condition: '{submissionDueDate}',
      conditionOperations: [{
        moduleName: 'Details',
        name: 'setSpecificDate',
        args: ['submissionDueDate']
      }],
      type: OperationType.conditional
    }, {
      windowType: WindowType.dialog,
      type: OperationType.closeWindow
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const filterCancelSubmissionFilesGrid: Action = [{
  name: 'resetGridData',
  moduleName: 'CancelSubmissionFilesGrid'
}, {
  name: 'cancelSubmissionFilesGridRequest',
  type: OperationType.action
}];

export const cancelSubmissionFilesGridRequest: Action = [{
  data: {
    url: '/targetsView',
  },
  mappingName: 'gridData',
  type: OperationType.request
}, {
  name: 'setGridData',
  moduleName: 'CancelSubmissionFilesGrid',
  args: ['gridData']
}];

export const getBatchesContentData: Action = [{
  name: 'getWorkflowData',
  moduleName: 'Content',
  mappingName: 'workflows',
  type: OperationType.addOperationData
}, {
  moduleName: 'Details',
  name: 'getTargetLanguage',
  mappingName: 'targetLanguageData',
  type: OperationType.addOperationData
}, {
  moduleName: 'Details',
  name: 'getProject',
  mappingName: 'projectData',
  type: OperationType.addOperationData
}, {
  name: 'setBatchContentData',
  moduleName: 'BatchesContent',
  args: ['workflows', 'targetLanguageData', 'projectData', 'batchInfos'],
  waitForModule: true
}];

export const changeSubmissionDueDate: Action = [{
  type: OperationType.addPersistentData,
  persistent: ['date', 'moduleId']
}, {
  warningType: WarningType.warning,
  placeholders: {
    template: {
      bind: {
        from: '{fromDate}',
        to: '{toDate}'
      }
    }
  },
  title: 'dueDateWarning.dueDateTitle',
  text: 'dueDateWarning.dueDateMessage',
  type: OperationType.warning,
  className: 'sm warning',
  items: [{
    operations: [{
      type: OperationType.removePersistentData,
      persistent: ['date', 'moduleId']
    }, {
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'dueDateWarning.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      data: {
        operation: undefined,
        template: {
          dateExtracted: {
            target: {
              bind: {
                value: '{date}',
              },
              props: {
                name: 'dueDate'
              }
            }
          }
        }
      },
      moduleName: 'MultiBatchUpload',
      name: 'changeBatchData',
      args: ['moduleId', 'operation', 'dateExtracted']
    }, {
      type: OperationType.removePersistentData,
      persistent: ['date', 'moduleId']
    }],
    btnName: 'dueDateWarning.okBtn',
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    }
  }]
}];

export const changeSubmissionDueDateByBatchDate: Action = [{
  type: OperationType.addPersistentData,
  persistent: ['event']
}, {
  warningType: WarningType.warning,
  placeholders: {
    template: {
      bind: {
        from: '{fromDate}',
        to: '{toDate}'
      }
    }
  },
  title: 'dueDateWarning.dueDateTitle',
  text: 'dueDateWarning.dueDateMessage',
  type: OperationType.warning,
  className: 'sm warning',
  items: [{
    operations: [{
      type: OperationType.removePersistentData,
      persistent: ['event']
    }, {
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'dueDateWarning.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'BatchesContent',
      name: 'changeSpecificBatchDates',
      args: ['event']
    }, {
      data: {
        template: {
          bind: {
            submissionDueDate: `new Date({event.value})`
          }
        }
      },
      type: OperationType.data
    }, {
      moduleName: 'Details',
      name: 'setSpecificDate',
      args: ['submissionDueDate'],
    }, {
      type: OperationType.removePersistentData,
      persistent: ['event']
    }],
    btnName: 'dueDateWarning.okBtn',
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    }
  }]
}];

export const updateBatchDates: Action = [{
  name: 'getBatchInfosLength',
  moduleName: 'Content',
  mappingName: 'batchInfosLength',
  type: OperationType.addOperationData
}, {
  condition: '{batchInfosLength > 1}',
  conditionOperations: [{
    name: 'updateBatchDueDates',
    moduleName: 'BatchesContent',
    args: ['date']
  }],
  elseOperations: [{
    condition: '({submissionMode} === "EDIT" || {submissionMode} === "CREATE")',
    conditionOperations: [{
      name: 'changeSimpleSubmissionBatchDueDate',
      moduleName: 'Content',
      args: ['date']
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const noDueDateWarning: Action = [{
  className: 'sm info footer-centered',
  warningType: WarningType.warning,
  text: 'noDueDateWarning.text',
  title: 'noDueDateWarning.title',
  type: OperationType.warning,
  items: [{
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'noDueDateWarning.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }]
}];

export const moveFiles: Action = [{
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{moduleId}',
  name: 'getFiles',
  type: OperationType.addOperationData
}, {
  moduleName: 'DropUpload',
  evaluate: true,
  name: 'getSelectedFiles',
  moduleId: '{removeFrom}',
  type: OperationType.addOperationData
}, {
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{removeFrom}',
  name: 'findUniquesAndCopies',
  args: ['getSelectedFiles', 'getFiles'],
  mappingName: 'filteredData',
  type: OperationType.addOperationData
}, {
  data: {
    template: {
      bind: {
        duplicates: '{filteredData.duplicates}',
        uniqueFiles: '{filteredData.unique}'
      }
    }
  },
  type: OperationType.data
}, {
  condition: '{duplicates.length === 0}',
  conditionOperations: [{
    name: 'executeMove',
    type: OperationType.action
  }],
  elseOperations: [{
    persistent: ['uniqueFiles', 'forceAdd', 'removeFrom', 'moduleId'],
    type: OperationType.addPersistentData,
  }, {
    name: 'moveFilesWarning',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const executeMove: Action = [{
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{removeFrom}',
  name: 'setDroppedFiles',
  args: ['uniqueFiles']
}, {
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{moduleId}',
  name: 'updateStateAndContinueUpload',
  args: ['uniqueFiles', 'folder', 'forceAdd']
}];

export const moveFilesWarning: Action = [{
  moduleName: 'DropUpload',
  evaluate: true,
  name: 'createMoveFilesMessageHeader',
  args: ['duplicates'],
  mappingName: 'headerData',
  type: OperationType.addOperationData
}, {
  warningType: WarningType.info,
  placeholders: {
    template: {
      bind: {
        files: '{headerData}',
      }
    }
  },
  title: 'duplicateFilesWarning.rejectedFiles',
  text: 'duplicateFilesWarning.moveFilesMessage',
  type: OperationType.warning,
  items: [{
    operations: [{
      persistent: ['uniqueFiles', 'forceAdd', 'removeFrom', 'moduleId'],
      type: OperationType.removePersistentData,
    }, {
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'duplicateFilesWarning.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      name: 'executeMove',
      type: OperationType.action
    }, {
      persistent: ['uniqueFiles', 'forceAdd', 'removeFrom', 'moduleId'],
      type: OperationType.removePersistentData,
    }],
    btnName: 'duplicateFilesWarning.okBtn',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    }
  }]
}];

export const templateEditValidateButtons: Action = [{
  name: 'validateButtons',
  moduleName: 'TemplateEdit',
  args: ['projectId']
}];

export const copyFilesToAllBatches: Action = [{
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{sourceModuleId}',
  name: 'getFiles',
  type: OperationType.addOperationData
}, {
  data: {
    forceAdd: true
  },
  moduleName: 'DropUpload',
  evaluate: true,
  moduleId: '{moduleId}',
  name: 'updateStateAndContinueUpload',
  args: ['getFiles', 'folder', 'forceAdd']
}];

export const removeFilesWithRestriction: Action = [{
  moduleName: 'MultiBatchUpload',
  args: ['moduleId'],
  name: 'getOtherModuleIds',
  type: OperationType.addOperationData
}, {
  moduleName: 'MultiBatchUpload',
  args: ['getOtherModuleIds'],
  name: 'getAllBatchesFilesData'
}];

export const collectModuleFiles: Action = [{
  evaluate: true,
  moduleName: 'DropUpload',
  moduleId: '{moduleId}',
  name: 'getFiles',
  type: OperationType.addOperationData
}, {
  moduleName: 'MultiBatchUpload',
  name: 'collectFilesData',
  args: ['getFiles'],
}, {
  condition: '{lastRequest}',
  conditionOperations: [{
    moduleName: 'MultiBatchUpload',
    name: 'checkForDuplicates',
    args: ['removeFileParams'],
    type: OperationType.addOperationData
  }, {
    condition: '{checkForDuplicates.tickets.length > 0}',
    conditionOperations: [{
      data: {
        method: 'post',
        url: '/submissions/delete/temporary',
        template: {
          bind: {
            params: '{checkForDuplicates}'
          }
        }
      },
      type: OperationType.request
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];

export const getWorkflowDetails: Action = [{
  name: 'workflowRequest',
  type: OperationType.action
}, {
  name: 'setWorkflowDetailsRequestData',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];


export const updateDetailsWithWorkflowState: Action = [{
  moduleName: 'Details',
  name: 'updateResetQuoteState',
  args: ['workflow']
}];

export const getWorkflowDetailsForStartedSubmission: Action = [{
  data: {
    method: 'get',
    template: {
      bind: {
        url: '"/submissions/"+ {submissionId} +"/workflows/" + {workflowId}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'workflowDetailsRequest',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{workflowDetailsRequest}'
      }
    }
  },
  name: 'handleRequestException',
  args: ['responseData'],
  type: OperationType.action
}, {
  name: 'setWorkflowDetailsRequestData',
  type: OperationType.action
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const setWorkflowDetailsRequestData = [{
  data: {
    template: {
      bind: {
        workflowDetails: '{workflowDetailsRequest}'
      }
    }
  },
  moduleName: 'AbstractSection',
  evaluate: true,
  moduleId: '{moduleId}',
  name: 'setWorkflowDetails',
  args: ['workflowDetails']
}];

export const showWarningSubmissionDueDate: Action = [{
  persistent: ['index', 'calculatedDueDates', 'newDateValue', 'moduleId'],
  type: OperationType.addPersistentData
}, {
  warningType: WarningType.info,
  title: 'showWarningSubmissionDueDate.title',
  text: 'showWarningSubmissionDueDate.text',
  type: OperationType.warning,
  items: [{
    operations: [{
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'showWarningSubmissionDueDate.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'PhaseDueDates',
      evaluate: true,
      name: 'setCalculatedDueDateAfterChange',
      moduleId: '{moduleId}',
      args: ['index', 'calculatedDueDates']
    }, {
      persistent: ['index', 'calculatedDueDates', 'newDateValue', 'moduleId'],
      type: OperationType.removePersistentData
    }, {
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'showWarningSubmissionDueDate.ok',
    btnConfig: {
      themeColor: 'primary',
      pos: Position.end
    },
    close: false
  }]
}];

export const warningPhaseDateWillReset: Action = [{
  persistent: ['moduleId'],
  type: OperationType.addPersistentData
}, {
  warningType: WarningType.warning,
  className: 'sm warning',
  title: 'warningPhaseDateWillReset.title',
  text: 'warningPhaseDateWillReset.text',
  type: OperationType.warning,
  items: [{
    operations: [{
      evaluate: true,
      moduleName: 'PhaseDueDates',
      name: 'clearFocus',
      moduleId: '{moduleId}'
    }, {
      persistent: ['moduleId'],
      type: OperationType.removePersistentData
    }],
    btnName: 'warningPhaseDateWillReset.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      evaluate: true,
      moduleName: 'PhaseDueDates',
      name: 'clearFocus',
      moduleId: '{moduleId}'
    }, {
      persistent: ['moduleId'],
      type: OperationType.removePersistentData
    }]
  }]
}];

export const changeSubmissionDueDateByPhaseDate: Action = [{
  persistent: ['index', 'calculatedDueDates', 'newDateValue', 'moduleId', 'batchDateParams'],
  type: OperationType.addPersistentData
}, {
  warningType: WarningType.warning,
  placeholders: {
    template: {
      bind: {
        from: '{fromDate}',
        to: '{toDate}'
      }
    }
  },
  title: 'dueDateWarning.dueDateTitle',
  text: 'dueDateWarning.dueDateMessage',
  type: OperationType.warning,
  className: 'sm warning',
  items: [{
    operations: [{
      evaluate: true,
      moduleName: 'PhaseDueDates',
      name: 'clearFocus',
      moduleId: '{moduleId}'
    }, {
      type: OperationType.removePersistentData,
      persistent: ['event', 'index', 'calculatedDueDates', 'newDateValue', 'moduleId', 'batchDateParams']
    }],
    btnName: 'dueDateWarning.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'Details',
      name: 'setSpecificDate',
      args: ['newDateValue'],
    }, {
      moduleName: 'PhaseDueDates',
      evaluate: true,
      name: 'setCalculatedDueDateAfterChange',
      moduleId: '{moduleId}',
      args: ['calculatedDueDates']
    }, {
      moduleName: 'AbstractSection',
      evaluate: true,
      name: 'setSpecificDate',
      moduleId: '{moduleId}',
      args: ['newDateValue', 'moduleId']
    }, {
      evaluate: true,
      moduleName: 'PhaseDueDates',
      name: 'clearFocus',
      moduleId: '{moduleId}'
    }, {
      persistent: ['index', 'calculatedDueDates', 'newDateValue', 'moduleId', 'batchDateParams'],
      type: OperationType.removePersistentData
    }],
    btnName: 'dueDateWarning.okBtn',
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      evaluate: true,
      moduleName: 'PhaseDueDates',
      name: 'clearFocus',
      moduleId: '{moduleId}'
    }, {
      persistent: ['event', 'index', 'calculatedDueDates', 'newDateValue', 'moduleId', 'batchDateParams'],
      type: OperationType.removePersistentData
    }]
  }]
}];


export const changeBatchDueDateByPhaseDate: Action = [{
  persistent: ['index', 'calculatedDueDates', 'newDateValue', 'moduleId', 'batchDateParams'],
  type: OperationType.addPersistentData
}, {
  warningType: WarningType.warning,
  placeholders: {
    template: {
      bind: {
        from: '{fromDate}',
        to: '{toDate}'
      }
    }
  },
  title: 'dueDateWarning.dueDateTitle',
  text: 'dueDateWarning.dueDateMessage',
  type: OperationType.warning,
  className: 'sm warning',
  items: [{
    operations: [{
      evaluate: true,
      moduleName: 'PhaseDueDates',
      name: 'clearFocus',
      moduleId: '{moduleId}'
    }, {
      type: OperationType.removePersistentData,
      persistent: ['event', 'index', 'calculatedDueDates', 'newDateValue', 'moduleId', 'batchDateParams']
    }, {
      windowType: WindowType.warning,
      type: OperationType.closeWindow
    }],
    btnName: 'dueDateWarning.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }, {
    operations: [{
      moduleName: 'PhaseDueDates',
      evaluate: true,
      name: 'setCalculatedDueDateAfterChange',
      moduleId: '{moduleId}',
      args: ['calculatedDueDates']
    }, {
      moduleName: 'AbstractSection',
      evaluate: true,
      name: 'setSpecificDate',
      moduleId: '{moduleId}',
      args: ['newDateValue', 'moduleId']
    }, {
      evaluate: true,
      moduleName: 'PhaseDueDates',
      name: 'clearFocus',
      moduleId: '{moduleId}'
    }, {
      persistent: ['index', 'calculatedDueDates', 'newDateValue', 'moduleId', 'batchDateParams'],
      type: OperationType.removePersistentData
    }],
    btnName: 'dueDateWarning.okBtn',
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    }
  }, {
    btnName: 'ESCAPE',
    operations: [{
      evaluate: true,
      moduleName: 'PhaseDueDates',
      name: 'clearFocus',
      moduleId: '{moduleId}'
    }, {
      persistent: ['event', 'index', 'calculatedDueDates', 'newDateValue', 'moduleId', 'batchDateParams'],
      type: OperationType.removePersistentData
    }]
  }]
}];

export const applyPhaseDueDatesToAllBatches: Action = [{
  moduleName: 'MultiBatchUpload',
  name: 'applyPhaseDueDatesToAllBatches',
  args: ['phaseDueDates']
}];

export const collectAllBatchesWorkflowPhases: Action = [{
  moduleName: 'AbstractSection',
  evaluate: true,
  moduleId: '{moduleId}',
  name: 'getWorkflowData',
  mappingName: 'workflowData',
  type: OperationType.addOperationData
}, {
  moduleName: 'MultiBatchUpload',
  name: 'storeWorkflowPhasesData',
  mappingName: 'batchData',
  args: ['workflowData', 'moduleId'],
  type: OperationType.addOperationData
}, {
  condition: '{all}',
  conditionOperations: [{
    moduleName: 'MultiBatchUpload',
    name: 'changeDueDatesToAllBatches'
  }],
  type: OperationType.conditional
}];

export const quoteWithdrawnWarning: Action = [{
  moduleName: 'View',
  name: 'getSubmissionSnapshot',
  mappingName: 'submissionSnapshot',
  type: OperationType.addOperationData
}, {
  name: 'getDataForEdit',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        quoteStatus: '{selectedSubmissions[0].quoteStatus}'
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'Edit',
  name: 'hasWithdrawnQuoteChanges',
  mappingName: 'hasChanges',
  args: ['submissionSnapshot', 'parsedData', 'quoteStatus'],
  type: OperationType.addOperationData
}, {
  condition: '{hasChanges}',
  conditionOperations: [{
    persistent: ['action', 'analyze', 'project', 'submissionId', 'submissionMode'],
    type: OperationType.addPersistentData
  }, {
    className: 'sm info',
    warningType: WarningType.info,
    text: 'withdrawnQuotes.text',
    title: 'withdrawnQuotes.title',
    type: OperationType.warning,
    items: [{
      operations: [{
        persistent: ['action', 'analyze', 'project', 'submissionId', 'submissionMode'],
        type: OperationType.removePersistentData
      }],
      btnName: 'withdrawnQuotes.cancel',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      operations: [{
        name: '{action}',
        evaluate: true,
        type: OperationType.action
      }, {
        persistent: ['action', 'analyze', 'project', 'submissionId', 'submissionMode'],
        type: OperationType.removePersistentData
      }],
      btnName: 'withdrawnQuotes.ok',
      btnConfig: {
        fillMode: 'flat',
        themeColor: 'primary',
        pos: Position.end
      }
    }]
  }],
  elseOperations: [{
    name: '{action}',
    evaluate: true,
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const getCalculatedDueDatesRequest: Action = [{
  moduleName: 'App',
  type: OperationType.maskModule
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    url: '/submissions/phaseDueDateCalculation'
  },
  mappingName: 'calculatedDueDates',
  type: OperationType.request
}, {
  moduleName: 'App',
  type: OperationType.unmaskModule
}];

export const getCalculatedDueDates: Action = [{
  name: 'getCalculatedDueDatesRequest',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        responseData: '{calculatedDueDates}'
      }
    }
  },
  name: 'handleRequestException',
  args: ['responseData'],
  type: OperationType.action
}, {
  condition: '{simpleBatch}',
  conditionOperations: [{
    args: ['responseData'],
    name: 'setCalculatedDueDates',
    moduleName: 'Content'
  }],
  elseOperations: [{
    args: ['responseData'],
    name: 'setCalculatedDueDates',
    evaluate: true,
    moduleId: '{phasesModuleId}',
    moduleName: 'PhaseDueDates'
  }],
  type: OperationType.conditional
}];

export const updateContentWorkflowInfo: Action = [{
  moduleName: 'Content',
  name: 'changeEditSubmissionWorkflow',
  args: ['workflowData']
}];

export const ignoreDueDateOnDetails: Action = [{
  moduleName: 'Details',
  name: 'setDueDateIgnoreField'
}];
